<template >

  <v-container >
    <v-layout justify-center>
      <v-dialog v-model="DialogUrgente" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ATTENZIONE</v-card-title>
          <v-card-text v-html="messageUrgente">{{ messageUrgente }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="DialogUrgente = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="dialogNotSave" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">CONFERMA</v-card-title>
          <v-card-text>Procedura di inserimento in ambiente di test andata a buon fine. Ti ricordiamo che i dati inseriti non sono stati memorizzati.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="IndietroLista()">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="erroreDettaglioColli" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">{{ $t('key308') }}</v-card-title>
          <v-card-text v-html="erroreDettaglio" >{{ erroreDettaglio }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="erroreDettaglioColli = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="erroreResa" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">{{ $t('key307') }}</v-card-title>
          <v-card-text >{{ messageResa }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="erroreResa = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="aggiungiADR" persistent max-width="800">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('key265') }} </span></v-card-title>
            <v-card-text>
                <v-form v-model="valid" ref="formadr">
                    <v-layout justify-center row wrap>
                        
                        <v-flex xs12 sm6 md3>
                            <v-text-field label="Codice ONU" v-model="codiceOnuInserito" :rules="[v=> !!v || 'Inserire un codice', v=> v.length < 5 || 'Sono ammessi al massimo 4 caratteri', v=> v.length === 4 || 'Il codice ONU deve essere lungo 4 caratteri' ]" :readonly="readonly"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md8>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm6 md4>
                            <v-text-field label="Classe ADR" v-model="classeADRInserita" :rules="[v=> v.length < 4 || 'Sono ammessi al massimo 3 caratteri' ]" :readonly="readonly"></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm6 md4>
                            <v-text-field label="Kg di ADR" v-model="kgADRInseriti" :readonly="readonly" @keypress="isFloat($event)" :rules="[v=> CheckPunti(v) || 'valore non valido']"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                        </v-flex>
                    </v-layout>
                </v-form>
                    </v-card-text>
                    <v-card-actions><v-btn @click="ChiudiAdr">{{ $t('key198') }}</v-btn>
                
                    <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" @click="InserisciADR" :disabled="!valid">{{ $t('key199') }}</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
      </v-layout>
     <v-layout justify-centerv-if="overlay">
       <v-dialog v-model="overlay" persistent max-width="600">
         <v-card>
           <v-card-text>
              <v-progress-linear
                indeterminate
                color="blue"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
    </v-layout>
    <v-layout justify-centerv-if="overlayCappario">
       <v-dialog v-model="overlay" persistent max-width="600">
         <v-card>
           <v-card-text>
              <v-progress-linear
                indeterminate
                color="blue"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="erroreValidazione" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">{{ $t('key307')}}</v-card-title>
          <v-card-text >{{ $t('key309') }} </v-card-text>
          <v-card-text v-html='errore'>{{ errore }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="erroreValidazione = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-card>
      
      <v-layout justify-center>
      <v-dialog v-model="DettaglioMisure" persistent max-width="800">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('key117') }} </span></v-card-title>
            <v-card-text>
                <v-form v-model="valid" name="dettaglio" ref="dettaglio">
                    <v-layout justify-center row wrap>
                        
                        <v-flex xs12 sm6 md3>
                            <v-text-field label="Colli" v-model="colliInseriti" :lazy-validation="true" :rules="[v=> v>0 || 'I colli non possono essere 0' ]" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs12 sm6 md8>
                        </v-flex>
                        <v-spacer></v-spacer> -->
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm6 md2>
                            <v-text-field label="Peso singolo collo(kg)" v-model="pesoInserito" :readonly="readonly" @keypress="isFloat($event)" :rules="[v=> CheckPunti(v) || 'valore non valido']"></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm6 md2>
                            <v-text-field label="Lunghezza (cm)" maxlength="3" v-model="lunghezzaInserita" :lazy-validation="true" :rules="[v=> v>0 || 'La lunghezza deve essere maggiore di 0 cm.']" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm6 md2>
                            <v-text-field label="Larghezza (cm)" maxlength="3" v-model="larghezzaInserita" :lazy-validation="true" :rules="[v=> v>0 || 'La larghezza deve essere maggiore di 0 cm.']" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm6 md2>
                            <v-text-field label="Altezza (cm)"  maxlength="3" v-model="altezzaInserita" :lazy-validation="true" :rules="[v=> v>0 || 'L`altezza deve essere maggiore di 0 cm.', v=> v < 271 || 'L`altezza deve essere minore di 270 cm.']" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>
                </v-form>
                    </v-card-text>
                    <v-card-actions><v-btn @click="ChiudiMisure">{{ $t('key118') }}</v-btn>
                
                    <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" @click="InserisciMisure" :disabled="!valid">{{ $t('key119')}}</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
      </v-layout>
      <v-layout justify-center>
        <v-dialog v-model="cappario" v-if="cappario" persistent max-width="1400">
          <v-card>
            <v-container>
              <v-text-field append-icon="search" label="Cerca" single-line hide-details v-model="searchCappario"></v-text-field>
    
                <v-data-table v-bind:headers="headersCappario" v-bind:items="this.$store.state.cappario" v-bind:search="searchCappario" >
                  <template slot="items" slot-scope="props">
                    <tr @click="SelezionaCappario(props.item.trploc, props.item.trpprv, props.item.trpcap)">
                        <td class="text-xs-left">{{ props.item.trploc }}</td>
                        <td class="text-xs-left">{{ props.item.trpprv }}</td>
                        <td class="text-xs-left">{{ props.item.trpcap }}</td>
                    </tr>
                  </template>
                  <template
                    slot="pageText"
                    slot-scope="{ pageStart, pageStop }"
                  >From {{ pageStart }} to {{ pageStop }}</template>
                </v-data-table>
                <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="ChiudiCappario">CHIUDI SENZA SELEZIONARE</v-btn>
            </v-container>
          </v-card>
      </v-dialog>
    </v-layout>
       <v-layout justify-center>
        <v-dialog v-model="rubrica" persistent max-width="1400">
            <v-card>
              <v-container> 
                <v-text-field append-icon="search" label="Cerca" single-line hide-details v-model="search"></v-text-field>
                  <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search">
                    <template slot="items" slot-scope="props">
                      <tr @click="selezionaRecordRubrica(props.item.ragioneSociale, props.item.indirizzo, props.item.comune, props.item.cap, props.item.provincia, props.item.giorniAperturaSettimanali,
                      props.item.oraAperturaMattino,props.item.oraChiusuraMattino, props.item.oraAperturaPomeriggio, props.item.oraChiusuraPomeriggio, props.item.numciv, props.item.telefono, props.item.telefono2,
                       props.item.email, props.item.email2)">
                        <td class="text-xs-left">{{ props.item.clientId }}</td>
                        <td class="text-xs-left">{{ props.item.ragioneSociale }}</td>
                        <td class="text-xs-left">{{ props.item.indirizzo }}</td>
                        <td class="text-xs-left">{{ props.item.comune }}</td>
                        <td class="text-xs-left">{{ props.item.cap }}</td>
                        <td class="text-xs-left">{{ props.item.provincia }}</td>
                        <td class="text-xs-left">{{ props.item.telefono }}</td>
                      </tr>
                    </template>
                    <template
                      slot="pageText"
                      slot-scope="{ pageStart, pageStop }"
                    >From {{ pageStart }} to {{ pageStop }}</template>
                  </v-data-table>
                  <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="rubrica = false" >CHIUDI SENZA SELEZIONARE</v-btn>
                </v-container>
            </v-card>
        </v-dialog>
    </v-layout>
      <v-container>
        <v-form v-model="validBolla">
        <v-layout justify-center row wrap>
          <v-flex xs12 sm12 md12>
            <h1>Dati destinatario</h1>
          </v-flex>
          <v-flex xs12 sm12 md5>
            <v-autocomplete  ref="ragSoc" v-if="numeroSpedizione == 0" label="Ragione sociale" v-model="ragioneSocialeDestinatario" maxlength="40" :readonly="readonly" :items="autocomplete"  :search-input.sync="selected" return-object></v-autocomplete>
            <v-text-field ref="ragSoc" v-if="numeroSpedizione != 0" label="Ragione sociale" v-model="ragioneSocialeDestinatario" maxlength = "40" :readonly="readonly"></v-text-field>
            </v-flex>
             <v-spacer></v-spacer>
            <v-flex xs10 sm10 md3>
                <v-text-field  label="Indirizzo" v-model="indirizzoDestinatario" maxlength = "40" :readonly="readonly"></v-text-field>
            </v-flex>
            <v-flex xs2 sm2 md1>
                <v-text-field  label="Civico" v-model="civico" maxlength = "4" :readonly="readonly"></v-text-field>
            </v-flex>
            <v-flex xs0 sm0 md2>
            </v-flex>
        <v-flex xs10 sm10 md3>
          <v-text-field  label="Località" v-model="localitaDestinatario" maxlength = "40" :readonly="readonly" append-icon ="search" @click:append="localitaDestinatario.trim().length > 2?OpenCappario(localitaDestinatario):OpenCappario('ERRORE')"></v-text-field>
        </v-flex>
        
        <v-flex xs12 sm6 md1>
          <v-text-field  label="Provincia" v-model="provinciaDestinatario" maxlength = "2" readonly ></v-text-field>
       </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs10 sm5 md1>
          <v-text-field  label="CAP" v-model="capDestinatario" maxlength = "5" :readonly="readonly" append-icon="search" @click:append="capDestinatario.toString().trim().length === 5?OpenCappario(capDestinatario):OpenCappario('ERRORE')"></v-text-field>
      </v-flex>
      <v-flex xs2 sm1 md1>
      <!-- <v-icon style="vertical-align: text-bottom;" v-if="!readonly" @click="capDestinatario.toString().trim().length === 5?OpenCappario(capDestinatario):OpenCappario('ERRORE')">search</v-icon> -->
      </v-flex>
      <v-flex xs12 sm6 md2>
          <v-text-field  label="DDT" v-model="riferimentoDdt" :readonly="readonly" maxlength = "30"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md4>
      </v-flex>
      <v-flex xs12 sm6 md2>
        <v-btn large style="box-shadow: none; color: white;" color="#A0A4A7" @click="rubrica = true" :hidden="readonly" lazy>RUBRICA</v-btn>
      </v-flex>
     
      <v-flex xs12 sm6 md2>
        <!-- <v-btn @click="OpenCappario">CAPPARIO</v-btn> -->
      </v-flex>
      <v-flex xs0 sm0 md8>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-checkbox
        v-model="preavvisare"
        label="Preavvisare tassativamente"
        :readonly="readonly"
        ></v-checkbox>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-text-field  v-if="preavvisare" label="Numero di telefono" v-model="telefonoPreavviso"  maxlength = "15" :readonly="readonly"></v-text-field>
      </v-flex>
      <v-flex xs0 sm0 md6>
        </v-flex>
      <v-flex xs12 sm6 md3>
        <v-checkbox
        v-model="emailMittenteTracking"
        label="Invia a me email tracking"
        :readonly="readonly"
        ></v-checkbox>
      </v-flex>
      <v-flex xs12 sm6 md9>
        </v-flex>
      <v-flex xs12 sm6 md3>
        <v-checkbox
        v-model="emailDestinatarioTracking"
        label="Invia al destinatario email tracking"
        :readonly="readonly"
        ></v-checkbox>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-text-field  v-if="emailDestinatarioTracking" label="indirizzo email" v-model="indirizzoMailDestinatario" :readonly="readonly" ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md6>
        </v-flex>
        </v-layout>
      <v-layout justify-center row wrap>
          <v-flex xs12 sm12 md12>
            <h1>Dati spedizione</h1>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field  label="Numero colli totale" v-model="numeroColli" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
            <v-text-field  label="Peso totale (kg)" v-model="peso" :readonly="readonly"  @keypress="isFloat($event)" :lazy-validation="true" :rules="[v=> CheckPunti(v) || 'valore non valido']"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
            <v-checkbox
              v-model="dettaglioColli"
              label="Dettaglio colli"
              :readonly="readonly"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 sm6 md1>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-data-table v-if="dettaglioColli" v-bind:headers="headersBancali" v-bind:items="MisureBancali"  :pagination.sync="pagination" >
                <template slot="items" slot-scope="props">
                    <tr>
                    <td class="text-xs-left">{{ props.item.miscll }}</td>
                    <td class="text-xs-left">{{ props.item.mispes }}</td>
                    <td class="text-xs-left">{{ props.item.mislun }}</td>
                    <td class="text-xs-left">{{ props.item.mislar }}</td>
                    <td class="text-xs-left">{{ props.item.misalt }}</td>
                    <td class="text-xs-right"><v-icon small class="mr-2" @click="editItem(props.item)" v-if="!readonly">edit</v-icon>
                    <v-icon small @click="deleteItem(props.item)" v-if="!readonly">delete</v-icon></td>
                    </tr>
                </template>
                <template
                    slot="pageText"
                    slot-scope="{ pageStart, pageStop }"
                >From {{ pageStart }} to {{ pageStop }}  </template>
            </v-data-table>
            <v-btn v-if="dettaglioColli && MisureBancali.length < 10 && !readonly" large style="box-shadow: none; color: white;" color="#4EABDD" @click="DettaglioMisure=true">AGGIUNGI DETTAGLIO</v-btn>
            <v-btn v-if="dettaglioColli && !readonly" large style="box-shadow: none; color: white;" color="#4EABDD" @click="Calcola">CALCOLA</v-btn>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field  label="Volume totale (mc)" v-model="volume" :readonly="readonly" @keypress="isFloat($event)" :rules="[v=> CheckPunti(v) || 'valore non valido']"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
         <v-flex xs12 sm6 md3>
            <v-text-field  label="Lunghezza (cm), obb. x > 200" maxlength="3" v-model="lunghezza" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
            <v-select
            
            v-model="misuraSelezionata"
            v-bind:items="misuraMaggiore"
            label="Misura maggiore"
            @change="GetMisura"
            :readonly="readonly"
          ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md1>
            </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field  label="Contrassegno (€)" v-model="contrassegno" :readonly="readonly" @keypress="isFloat($event)" :rules="[v=> CheckPunti(v) || 'valore non valido']"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
            <v-text-field  locales='it-IT' label="Valore merce (€)" v-model="valoreMerce" :readonly="readonly" @keypress="isFloat($event)" :rules="[v=> CheckPunti(v) || 'valore non valido']"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3> 
         <v-select
            
            v-if="CheckContrassegno(contrassegno)"
            v-model="incassoSelezionato"
            v-bind:items="incasso"
            label="Tipo Incasso"
            @change="GetTipoIncasso"
            :readonly="readonly"
          ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md1>
            </v-flex>
           <v-flex xs12 sm6 md3> 
         <v-select
            
            v-model="dispo1Selezionata"
            v-bind:items="disposizioni1"
            label="Disposizioni particolari 1"
            @change="GetDisposizioni1"
            :readonly="readonly"
          ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3> 
         <v-select
            
            v-model="dispo2Selezionata"
            v-bind:items="disposizioni2"
            label="Disposizioni particolari 2"
            @change="GetDisposizioni2"
            :readonly="readonly || readonlyurgente"
          ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
          <v-select
            
            v-model="servizioAggiuntivoSelezionato"
            v-bind:items="serviziAggiuntivi"
            label="Servizi aggiuntivi"
            @change="GetServizioAggiuntivo"
            :readonly="readonly"
          ></v-select>
          </v-flex>
          <v-flex xs0 sm0 md1>
            </v-flex>
          <v-flex xs0 sm0 md8>
            </v-flex>
          <v-flex xs12 sm6 md3>
             <v-text-field  v-if="mostraPiano" label="Piano di consegna" v-model="pianoConsegna" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
          </v-flex>
          <v-flex xs0 sm0 md1>
            </v-flex>
          <v-flex xs12 sm12 md12>
          <v-data-table v-if="mostraADR" v-bind:headers="headersADR" v-bind:items="datiADR"  :pagination.sync="pagination" >
                <template slot="items" slot-scope="props">
                    <tr>
                    <td class="text-xs-left">{{ props.item.tadonu }}</td>
                    <td class="text-xs-left">{{ props.item.tadcls }}</td>
                    <td class="text-xs-left">{{ props.item.pesokg }}</td>
                    <td class="text-xs-right"><v-icon small class="mr-2" @click="editAdr(props.item)" v-if="!readonly">edit</v-icon>
                    <v-icon small @click="deleteAdr(props.item)" v-if="!readonly">delete</v-icon></td>
                    </tr>
                </template>
                <template
                    slot="pageText"
                    slot-scope="{ pageStart, pageStop }"
                >From {{ pageStart }} to {{ pageStop }}  </template>
            </v-data-table>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" v-if="mostraADR && datiADR.length < 10 && !readonly" @click="aggiungiADR = true">AGGIUNGI RIGA</v-btn>
          </v-flex>
          <v-flex xs12 sm6 md3> 
         <v-select
            
            v-if="showEpal"
            v-model="epalARendere"
            v-bind:items="[{text: 'SI', value: 1}, {text: 'NO', value: 0}]"
            label="Epal a rendere"
            @change="Epal"
            :readonly="readonly"
          ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
             <v-text-field  v-if="sceltaEpal === 1" lazy label="Quantità Epal" v-model="epalDaRendere" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
          </v-flex>
          <v-flex xs0 sm0 md5>
            </v-flex>
          <v-flex xs12 sm6 md5>
            <v-checkbox
            v-model="scansioneLDV"
            label="SCANSIONARE LDV + DDT DA RENDERE AL CLIENTE"
            :readonly="readonly"
            ></v-checkbox>
      </v-flex>
      <v-flex xs12 sm6 md3>
            <v-checkbox
            v-model="centroStorico"
            label="Centro storico"
            :readonly="readonly"
            ></v-checkbox>
      </v-flex>
      <v-flex xs0 sm0 md4>
        </v-flex>
      <v-flex xs12 sm6 md4>
            <v-checkbox
            v-model="concordataTassativa"
            label="Consegna Concordata / Tassativa"
            :readonly="readonly"
            @change="CambiaTassSelezionata"
            ></v-checkbox>
      </v-flex>
       <v-flex xs12 sm6 md3> 
         <v-select
            
            v-if="concordataTassativa"
            v-model="tassativaSelezionata"
            v-bind:items="tassativa"
            label="Tassativa"
            @change="GetTassativa"
            :readonly="readonly"
          ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
              <v-dialog
              v-if="concordataTassativa"
                ref="dialog"
                v-model="dataP"
                :return-value.sync="data_partenza"
                persistent
                lazy
                full-width
                width="290px"
                :readonly="readonly"
                
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    
                    v-model="data_partenza"
                    label="Da data: "
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    
                  ></v-text-field>
                </template>
                <v-date-picker locale="it-IT" v-model="data_partenza" scrollable :min="minPartenza" :max="maxPartenza">
                  <v-spacer></v-spacer>
                  <v-btn flat color="#4EABDD" @click="data_partenza = false">Annulla</v-btn>
                  <v-btn flat color="#4EABDD" @click="checkFinale">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs0 sm0 md1>
            </v-flex>  
      </v-layout>
      
          <v-flex xs12 sm12 md12>
            <h1>Giorni di chiusura</h1>
          </v-flex>
           <v-layout :wrap="true" d-flex>
        <v-flex xs12 sm10 md4 d-flex>

        <v-radio-group v-model="lunedi" row>
          <h3>Lunedì: </h3>
          <v-spacer></v-spacer>
          <v-radio
            v-for="n in 4"
            :key="n"
            :label="Radio[n-1]"
            :value="n"
            :readonly="readonly"
          ></v-radio>
      </v-radio-group>
      <v-radio-group v-model="martedi" row>
          <h3>Martedì: </h3>
          <v-spacer></v-spacer>
          <v-radio
            v-for="n in 4"
            :key="n"
            :label="Radio[n-1]"
            :value="n"
            :readonly="readonly"
          ></v-radio>
      </v-radio-group>
      <v-radio-group v-model="mercoledi" row>
          <h3>Mercoledì: </h3>
          <v-spacer></v-spacer>
          <v-radio
            v-for="n in 4"
            :key="n"
            :label="Radio[n-1]"
            :value="n"
            :readonly="readonly"
          ></v-radio>
      </v-radio-group>
      <v-radio-group v-model="giovedi" row>
          <h3>Giovedì: </h3>
          <v-spacer></v-spacer>
          <v-radio
            v-for="n in 4"
            :key="n"
            :label="Radio[n-1]"
            :value="n"
            :readonly="readonly"
          ></v-radio>
      </v-radio-group>
      <v-radio-group v-model="venerdi" row>
          <h3>Venerdì: </h3>
          <v-spacer></v-spacer>
          <v-radio
            v-for="n in 4"
            :key="n"
            :label="Radio[n-1]"
            :value="n"
            :readonly="readonly"
          ></v-radio>
      </v-radio-group>
      </v-flex>
           </v-layout>
<v-layout justify-center row wrap>
       <v-flex xs6 sm6 md4>
          <h3>Orario apertura mattino</h3>
        </v-flex>
        <v-flex xs6 sm6 md8>
          <h3>Orario chiusura mattino</h3>
        </v-flex>
        <v-flex xs3 sm3 md1>
          <v-text-field  label="ora" v-model="oreAMattino" maxlength = "2" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
        </v-flex>
        <v-flex xs3 sm3 md1>
          <v-text-field  label="minuti" v-model="minutiAMattino" maxlength = "2" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
        </v-flex>
        <v-flex xs0 sm0 md2>
        </v-flex>
          
          <v-spacer></v-spacer>
       <v-flex xs3 sm3 md1>
            <v-text-field  label="ora" v-model="oreCMattino" maxlength = "2" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
          </v-flex>
       <v-flex xs3 sm3 md1>
            <v-text-field  label="minuti" v-model="minutiCMattino" maxlength = "2" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
          </v-flex>
          <v-flex xs0 sm0 md6>
        </v-flex>
        <v-flex xs6 sm6 md4>
          <h3>Orario apertura pomeriggio</h3>
        </v-flex>
        <v-flex xs6 sm6 md8>
          <h3>Orario chiusura pomeriggio</h3>
        </v-flex>
        <v-flex xs3 sm3 md1>
          <v-text-field  label="ora" v-model="oraAPomeriggio" maxlength = "2" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
        </v-flex>
        <v-flex xs3 sm3 md1>
          <v-text-field   label="minuti" v-model="minutiAPomeriggio" maxlength = "2" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
        </v-flex>
        <v-flex xs0 sm0 md2>
        </v-flex>
          
          <v-spacer></v-spacer>
       <v-flex xs3 sm3 md1>
            <v-text-field  label="ora" v-model="oraCPomeriggio" maxlength = "2" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
          </v-flex>
       <v-flex xs3 sm3 md1>
            <v-text-field  label="minuti" v-model="minutiCPomeriggio" maxlength = "2" :readonly="readonly" @keypress="isInteger($event)"></v-text-field>
          </v-flex>
          <v-flex xs0 sm0 md6>
        </v-flex>
        <v-flex xs12 sm12 md12>
          <v-text-field  v-if="Number(permessoNote) == 1" label="Note" v-model="notspe" maxlength = "40" :readonly="readonly"></v-text-field>
          </v-flex>
      </v-layout>
      <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" v-if="!readonly" @click="Reset" :disabled="disable">PULISCI CAMPI</v-btn>
      <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" v-if="!readonly" @click="Validate" :disabled="!validBolla">SALVA</v-btn>
      <!-- <v-btn v-if="!readonly" @click="StampaImmediataA4()">SALVA + STAMPA A4</v-btn>
      <v-btn v-if="!readonly" @click="StampaImmediata10()">SALVA + STAMPA 10 x 10</v-btn> -->
      <v-btn  large style="box-shadow: none; color: white;" color="#A0A4A7" @click="Indietro">INDIETRO</v-btn>
      </v-form>
      </v-container>
      
    </v-card>
    
  </v-container>
</template>


<script>
import axios from "axios";
export default {
 
  data: () => ({
    numeroSpedizione: 0,
    ElencoDisposizioni1: [],
    ElencoDisposizioni2: [],
    forzaUrgente: false,
    readonlyurgente: false,
    messageUrgente: "",
    DialogUrgente: false,
    permessoNote: 0,
    dialogNotSave: false,
    autocompletamento: {},
    selected: null,
    autocomplete: [],
    validBolla: false,
    erroreDettaglio : "",
    erroreDettaglioColli : false,
    stampaImmediataA4: 0,
    stampaImmediata10: 0,
    collante: "",
    erroreResa: false,
    messageResa: "",
    tassativaSelezionata: {value: -1},
    sceltaEpal : 0,
    epalDaRendere: 0,
    epalARendere: {text: 'NO', value: 0},
    incasso: [],
    oreAMattino: "",
    oreCMattino: "",
    dataP: false,
    minutiAMattino: "",
    minutiCMattino: "",
    oraAPomeriggio: "",
    oraCPomeriggio: "",
    minutiAPomeriggio: "",
    import: 0,
    import_r: 0,
    minutiCPomeriggio: "",
    pagination: { rowsPerPage: 10 },
    MisureBancali: [],
    valid: false,
    oreMattino: "",
    minutiMattino: "",
    orePomeriggio: "",
    minutiPomeriggio: "",
    lunedi: 1,
    martedi: 1,
    mercoledi: 1,
    giovedi: 1,
    venerdi: 1,
    sabato: "",
    domenica: "",
    search: "",
    disable: false,
    searchCappario: "",
    emailMittenteTracking: 0,
    data_partenza: "",
    scansioneLDV: false,
    centroStorico: false,
    concordataTassativa: false,
    modifica: false,
    modificaForm: false,
    contrassegno: "0",
    valoreMerce: 0,
    colliInseriti: 0,
    pesoInserito: 0,
    lunghezzaInserita: 0,
    larghezzaInserita: 0,
    altezzaInserita: 0,
    DettaglioMisure: false,
    numeroColli: 0,
    peso: 0,
    civico: "",
    volume: 0,
    lunghezza: 0,
    indirizzoMailDestinatario: "",
    emailDestinatarioTracking: 0,
    preavvisare: false,
    telefonoPreavviso: "",
    cappario: false,
    pesoTotale: 0,
    disposizioni1: [],
    disposizioni2: [],
    headers: [
        { text: "Identificativo", align: "left", value: "clientId" },
        { text: "Ragione sociale", align: "left", value: "ragioneSociale" },
        { text: "Indirizzo", align: "left", value: "indirizzo" },
        { text: "Comune", align: "left", value: "comune" },
        { text: "Cap", align: "left", value: "cap" },
        { text: "Provincia", align: "left", value: "provincia" },
        { text: "Telefono", align: "left", value: "telefono" },
    ],
    headersCappario: [
        { text: "Località", align: "left", value: "trploc" },
        { text: "Provincia", align: "left", value: "trpprv" },
        { text: "CAP", align: "left", value: "trpcap" },
    ],
    items: [],
    volumeTotale: 0,
    ragioneSocialeDestinatario: "",
    indirizzoDestinatario: "",
    localitaDestinatario: "",
    provinciaDestinatario: "",
    capDestinatario: "",
    riferimentoDdt: "",
    rubrica: false,
    mostraTel: false,
    dettaglioColli: false,
    misuraSelezionata: {text: "NON IMPOSTATA", value: 0},
    misuraMaggiore: [
      {text: "NON IMPOSTATA", value: 0},
      {text: "LUNGHEZZA / LARGHEZZA", value: 1},
      {text: "ALTEZZA", value: 2},
    ],
    Radio: ["Mai", "Mattina", "Pomeriggio", "Tutto il giorno"],
    dispo1Selezionata: {text: "NESSUNO", value: " "},
    dispo2Selezionata: {text: "NESSUNO", value: " "},
    
    servizioAggiuntivoSelezionato: {text: "NESSUNO", value: " "},
   
    // tassativa: [
    //   {text: "CONSEGNA TASSATIVA ENTRO IL", value: 0},
    //   {text: "CONSEGNA TASSATIVA SOLO IL", value: 1},
    //   {text: "SCARICO PRENOTATO IL", value: 2},
    //   {text: "CONSEGNA TASSATIVA PER IL", value: 3},
    //   {text: "CONSEGNA TASSATIVA DOPO IL", value: 4},
    // ],
    tassativeAmmesse: [0,1,2,4, "0", "1", "2", "4"],
    tassativa: [
      {text: "CONSEGNA TASSATIVA ENTRO IL", value: 0},
      {text: "CONSEGNA TASSATIVA SOLO IL", value: 1},
      {text: "SCARICO PRENOTATO IL", value: 2},
      //{text: "CONSEGNA TASSATIVA PER IL", value: 3},
      {text: "CONSEGNA TASSATIVA DOPO IL", value: 4},
    ],
    headersBancali: [
        { text: "Numero colli", align: "left", value: "colli" },
        { text: "Peso", align: "left", value: "peso" },
        { text: "Lunghezza", align: "left", value: "lunghezza" },
        { text: "Larghezza", align: "left", value: "larghezza" },
        { text: "Altezza", align: "left", value: "altezza" },
      ],
    misuraScelta: 0,
    dispo1Scelta: " ",
    dispo2Scelta: " ",
    servizioScelto: "",
    incassoSelezionato: "",
    serviziAggiuntivi: [],
    errore: "",
    ColliTotali: "",
    elencoIncassi: [],
    modificaBolleStampate : 0,
    contrMaxValue: "",
    contrMinValue: "",
    preavvisoObbligatorio: "",
    tipoIncasso: " ",
    erroreValidazione: "",
    obbligoVolume: "",
    pesoPerDettaglioColli: 999999999999,
    readonly: false,
    statoSpedizione: "",
    JsonModifica: {},
    modifica: false,
    modificaAdr: false,
    mostraADR: false,
    mostraPiano: false,
    headersADR: [
        { text: "Codice ONU", align: "left", value: "codiceONU" },
        { text: "Classe ADR", align: "left", value: "classeADR" },
        { text: "Kg di ADR", align: "left", value: "kgADR" },
      ],
    datiADR: [],
    elencoADR: [],
    elencoEPAL: [],
    elencoPIANO: [],
    aggiungiADR: false,
    codiceOnuInserito: "",
    classeADRInserita: "",
    kgADRInseriti: 0,
    indiceModificaAdr: "",
    showEpal: true,
    overlay: true,
    capparioRicevuto: false,
    overlayCappario: false,
    //inizializzo i campi in sola lettura quando carico una bolla
    notspe: "",
    fildes: "",
    gatdes: "",
    instrada: "",
    datdis: "",
    segsta: "",
    insalt: "",
    mitrag: "",
    mitind: "",
    mitloc: "",
    mitcap: "",
    mitprv: "",
    palaper: "",
    notsave: "0",
  }),
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    
    this.CheckNote();
    this.checkPermessi();
    this.GetBolleDestino();
    this.capparioRicevuto = this.$store.state.cappario_ricevuto;
    //console.log("Cappario ricevuto: " + this.capparioRicevuto);
    this.$store.subscribe((mutation, state) => {
      if(mutation.type === "stato_cappario" && mutation.payload === true){
        //console.log("Cappario scaricato");
        
      }
      if(mutation.type === "cappario"){
        this.capparioRicevuto = true;
        this.overlay = false;
      }
    });
    
    this.CheckJWT();
    this.getDisposizioni();
    this.numeroSpedizione = this.$route.params.codiceSpedizione;
    this.statoSpedizione = this.$route.params.stato;
   //this.GetDataFromService();
    this.GetIncassi();
    this.maxPartenza = this.addDays(new Date(), 365)
        .toISOString()
        .substr(0, 10);
    this.minPartenza = this.addDays(new Date(), 1)
        .toISOString()
        .substr(0, 10);
	  this.minFinale = this.data_partenza;
    this.maxFinale = this.addDays(new Date(), 365)
        .toISOString()
        .substr(0, 10);
  },

  methods: {
    CheckNote(){
       axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/NOTEABIL").
            then(res=> {
                this.permessoNote = res.data;
    });
    },
    checkPermessi(){
      axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/NOT-SAVE").
            then(res=> {
                this.notsave = res.data;
    });
    },
     isInteger( evt ) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }            
        },
    isFloat( evt ) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if(charCode === 44){
          return true;
        }
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
        } else {
            return true;
        }            
    },
    Epal(event){
      this.sceltaEpal = event;
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
    checkFinale() {
      this.ControllaUrgente();
      this.$refs.dialog.save(this.data_partenza);
      this.minFinale = this.data_partenza;
      this.maxFinale = new Date().toISOString().substr(0, 10);
    },
    GetTassativa(sel){
      this.tassativaSelezionata = {value : sel};
      this.ControllaUrgente();
    },
    GetIncassi(){
       this.incasso = [{text: "NESSUNO", value: " "}];
       this.elencoIncassi = [];
       this.elencoIncassi[" "] = {};
       var servcount = 0;
       this.incassoSelezionato = {text: "NESSUNO", value: " "};
       axios.get(this.$store.state.servicePath + "/api/ArTipoIncassoContrassegnoes").then(res => {
         res.data.forEach(el=>{
           var element = {text: el.descrizione.trim(), value: el.codice.trim()};
           this.incasso.push(element);
           this.elencoIncassi[el.codice.trim()] = el;
            // if(servcount === 0){
            //   this.incassoSelezionato = {text: el.descrizione.trim(), value: el.codice.trim()};
            //   this.tipoIncasso = el.codice;
            //   this.contrMaxValue = el.valoreMassimo;
            //   this.contrMinValue = el.valoreMinimo;
            //   this.preavvisoObbligatorio = el.preavvisoObbligatorio;
            //   servcount ++;
            // }
            // else{
            //   servcount ++;
            // }
                
         });
         this.CheckObbligoDettaglio();   
       });
    },
    GetStati(){
    },
    GetTipoIncasso(event){
      this.tipoIncasso = event;
      if(this.tipoIncasso!=" ") {
        this.contrMaxValue = this.elencoIncassi[event.trim()].valoreMassimo;
        this.contrMinValue = this.elencoIncassi[event.trim()].valoreMinimo;
        this.preavvisoObbligatorio = this.elencoIncassi[event.trim()].preavvisoObbligatorio;
      } 
      
    },
    Cerca(){
    },
    getDataFromService() {
            axios.get(this.$store.state.servicePath + "/api/ArRubricaClientis").then(res => {
                this.items = [];
                res.data.forEach(el=>{
                  el.ragioneSociale = el.ragioneSociale.replace("''", "'");
                  el.indirizzo = el.indirizzo.replace("''", "'");
                  el.cap = el.cap.replace("''", "'");
                  el.comune = el.comune.replace("''", "'");
                  el.provincia = el.provincia.replace("''", "'");
                  this.items.push(el);
                })
                //this.GetIncassi();
            });
            
    },
    getDisposizioni() {
            var disp1count = 0;
            var disp2count = 0;
            var servcount = 0;
            axios.get(this.$store.state.servicePath + "/api/ArDisposizionis").then(res => {
                res.data.forEach(el =>{
                  this.elencoADR[el.codice.trim()] = [];
                  this.elencoADR[el.codice.trim()] = el.showAdr;
                  this.elencoEPAL[el.codice.trim()] = [];
                  this.elencoEPAL[el.codice.trim()] = el.showEpal;
                  this.elencoPIANO[el.codice.trim()] = [];
                  this.elencoPIANO[el.codice.trim()] = el.showConsPiano;
                  if(el.isDisposizione1 === 1){
                    this.ElencoDisposizioni1.push(el.codice.trim());
                    if(el.codice.trim()!== "U"){
                    if(el.descrizione.trim() !== "NESSUNO")
                        this.disposizioni1.push({text: el.descrizione, value: el.codice.trim()});
                      else{
                        this.disposizioni1.push({text: el.descrizione, value: " "});
                      }
                    }
                    this.dispo1Selezionata = {value: " "}
                    // if(disp1count === 0){
                    //   this.dispo1Selezionata = {text: el.descrizione, value: el.codice.trim()};
                    //   disp1count ++;
                    // }
                    // else{
                    //   disp1count ++;
                    // }
                  }
                  if(el.isDisposizione2 === 1){
                    this.ElencoDisposizioni2.push(el.codice.trim());
                    if(el.codice.trim()!== "U"){
                      if(el.descrizione.trim() !== "NESSUNO")
                          this.disposizioni2.push({text: el.descrizione, value: el.codice.trim()});
                      else{
                          this.disposizioni2.push({text: el.descrizione, value: " "});
                        }
                    }
                    else{
                      if(this.forzaUrgente)
                        this.disposizioni2.push({text: el.descrizione, value: el.codice.trim()});
                    }
                    this.dispo2Selezionata = {value: " "}
                    // if(disp2count === 0){
                    //   this.dispo2Selezionata = {text: el.descrizione, value: el.codice.trim()};
                    //   disp2count ++;
                    // }
                    // else{
                    //   disp2count ++;
                    // }
                  }
                  if(el.isServiziAggiuntivi === 1){
                    if(el.descrizione.trim() !== "NESSUNO")
                        this.serviziAggiuntivi.push({text: el.descrizione, value: el.codice.trim()});
                      else{
                        this.serviziAggiuntivi.push({text: el.descrizione, value: " "});
                      }
                    //this.serviziAggiuntivi.push({text: el.descrizione, value: el.codice.trim()})
                    if(servcount === 0){
                      if(el.descrizione.trim() !== "NESSUNO")
                        this.servizioAggiuntivoSelezionato = {text: el.descrizione, value: el.codice.trim()};
                      else{
                        this.servizioAggiuntivoSelezionato = {value: " "};
                      }
                      servcount ++;
                    }
                    else{
                      servcount ++;
                    }
                    
                  }
                  //console.log(this.disposizioni1);
                   
                });
                //this.items = res.data;
                this.getDataFromService();
            });
    },
    selezionaRecordRubrica(ragioneSociale, indirizzo, comune, cap, provincia, giorni, apMattina, chMattina, apPomeriggio, chPomeriggio, numciv, telefono, telefono2, email, email2){
      this.ragioneSocialeDestinatario = ragioneSociale != null ?ragioneSociale.replace("''", "'").substring(0,50): "";
      this.indirizzoDestinatario = indirizzo != null ? indirizzo.replace("''", "'").substring(0,50) : "";
      this.localitaDestinatario = comune != null ? comune.replace("''", "'").substring(0,50) : "";
      this.capDestinatario = cap != null ? cap.replace("''", "'").substring(0,5) : "";
      this.provinciaDestinatario = provincia != null ? provincia.replace("''", "'").substring(0,2) : "";
      this.civico = numciv != null ? numciv.replace("''", "'") : "";
      this.lunedi = giorni.substr(0,1) === " "?1:giorni.substr(0,1) === "M"?2:giorni.substr(0,1) === "P"?3:4;
      this.martedi = giorni.substr(1,1) === " "?1:giorni.substr(1,1) === "M"?2:giorni.substr(1,1) === "P"?3:4;
      this.mercoledi = giorni.substr(2,1) === " "?1:giorni.substr(2,1) === "M"?2:giorni.substr(2,1) === "P"?3:4;
      this.giovedi = giorni.substr(3,1) === " "?1:giorni.substr(3,1) === "M"?2:giorni.substr(3,1) === "P"?3:4;
      this.venerdi = giorni.substr(4,1) === " "?1:giorni.substr(4,1) === "M"?2:giorni.substr(4,1) === "P"?3:4;
      this.oreAMattino = apMattina != null ? apMattina.substring(0,2) : "";
      this.minutiAMattino = apMattina != null ? apMattina.substring(2,4) : "";
      this.oreCMattino = chMattina != null ? chMattina.substring(0,2) : "";
      this.minutiCMattino = chMattina != null ? chMattina.substring(2,4) : "";
      this.oraAPomeriggio = apPomeriggio != null ? apPomeriggio.substring(0,2) : "";
      this.minutiAPomeriggio = apPomeriggio != null ? apPomeriggio.substring(2,4) : "";
      this.oraCPomeriggio = chPomeriggio != null ? chPomeriggio.substring(0,2) : "";
      this.minutiCPomeriggio = chPomeriggio != null ? chPomeriggio.substring(2,4) : "";
      if(telefono != null && telefono != ""){
        this.telefonoPreavviso = telefono.replace("''", "'");
      }
      else if(telefono2 != null && telefono2 != ""){
        this.telefonoPreavviso = telefono2.replace("''", "'");
      }
      if(email != null && email != ""){
        this.indirizzoMailDestinatario = email.replace("''", "'");
      }
      else if(email2 != null && email2 != ""){
        this.indirizzoMailDestinatario = email2.replace("''", "'");
      }
      this.autocomplete.push(ragioneSociale);
      this.autocompletamento[ragioneSociale] = {desrag: ragioneSociale, desind: indirizzo, desciv: numciv, desloc: comune, desprv: provincia, descap: cap};
      this.import = 2;
      this.rubrica = false;
    },
    OpenCappario(cerca){
      if(!this.capparioRicevuto){
        this.overlay = true;
      }
      else{
        this.overlay = false;
        if(cerca !== "ERRORE"){
            this.searchCappario = cerca.trim();
            this.cappario = true;
        } 
        else{
            this.errore = "";
            this.errore += "- Per eseguire una ricerca sul cappario, devi inserire un cap lungo 5 caratteri o una località lunga almeno 2 caratteri";
            this.erroreValidazione = true;
        }
      }
    },
    ChiudiCappario(){
      //this.searchCappario = "";
      this.cappario = false;
    },
    SelezionaCappario(localita, provincia, cap){
      this.localitaDestinatario = localita;
      this.provinciaDestinatario = provincia;
      this.capDestinatario = cap;
      this.cappario = false;
      // this.searchCappario = "";
    },
    ChiudiAdr(){
      this.indiceModificaAdr = "";
      this.modificaAdr = false;
      this.aggiungiADR = false;
      this.codiceOnuInserito = "";
      this.classeADRInserita = "";
      this.kgADRInseriti = "";
      this.$refs.formadr.resetValidation()
    },
    InserisciADR(){
      
        if(this.modificaAdr === false){
          this.aggiungiADR = false;
          this.datiADR.push({tadonu: this.codiceOnuInserito, tadcls: this.classeADRInserita, pesokg: this.kgADRInseriti});
          this.codiceOnuInserito = "";
          this.classeADRInserita = "";
          this.kgADRInseriti = "";
      }
      else{
        this.aggiungiADR = false,
        Object.assign(this.datiADR[this.indiceModificaAdr], {tadonu: this.codiceOnuInserito, tadcls: this.classeADRInserita, pesokg: this.kgADRInseriti})
        this.modificaAdr = false
        this.codiceOnuInserito = "";
        this.classeADRInserita = "";
        this.kgADRInseriti = "";
        }
        this.$refs.formadr.resetValidation()
    },
    ChiudiMisure(){
      this.DettaglioMisure = false;
      this.indiceModifica = 0;
      this.modifica = false;
      this.colliInseriti = 0;
      this.lunghezzaInserita = 0;
      this.larghezzaInserita = 0;
      this.altezzaInserita = 0;
      this.pesoInserito = 0;
      this.$refs.dettaglio.resetValidation();
    },
    InserisciMisure(){
      
    if(this.modifica === false){
               
      this.DettaglioMisure = false;
      this.MisureBancali.push({mispes: this.pesoInserito, miscll: this.colliInseriti, mislun: this.lunghezzaInserita, mislar: this.larghezzaInserita, misalt:this.altezzaInserita});
      this.colliInseriti = 0;
      this.lunghezzaInserita = 0;
      this.larghezzaInserita = 0;
      this.altezzaInserita = 0;
      this.pesoInserito = 0;
      
        
    }
    else{
        
        this.DettaglioMisure = false,
        Object.assign(this.MisureBancali[this.indiceModifica], {mispes: this.pesoInserito, miscll: this.colliInseriti, mislun: this.lunghezzaInserita, mislar: this.larghezzaInserita, misalt:this.altezzaInserita})
        this.modifica = false
        this.pesoInserito = 0;
        this.colliInseriti = 0;
        this.lunghezzaInserita = 0;
        this.larghezzaInserita = 0;
        this.altezzaInserita = 0;
        }
      this.lunghezza = 0;
      this.misuraSelezionata = {value : 0};
      this.misuraScelta = 0;
      this.MisureBancali.forEach(el=>{
            
            if(Number(el.mislun) > Number(this.lunghezza) && Number(el.mislun) > 200){
                this.lunghezza = el.mislun;
                this.misuraSelezionata = {value : 1};
                this.misuraScelta = 1;
            }
            if(Number(el.misalt) > Number(this.lunghezza) && Number(el.misalt) > 200){
                this.lunghezza = el.misalt;
                this.misuraSelezionata = {value : 2};
                this.misuraScelta = 2;
            }
            if(Number(el.mislar) > Number(this.lunghezza) && Number(el.mislar) > 200){
                this.lunghezza = el.mislar;
                this.misuraSelezionata = {value : 1};
                this.misuraScelta = 1;
            }
        });
        this.$refs.dettaglio.resetValidation();
    },
    editItem (item){
      this.indiceModifica = this.MisureBancali.indexOf(item)
      this.modifica = true;
      this.pesoInserito = item.mispes;
      this.colliInseriti = item.miscll;
      this.lunghezzaInserita = item.mislun;
      this.larghezzaInserita = item.mislar;
      this.altezzaInserita = item.misalt;
      this.DettaglioMisure = true;
    },
    editAdr (item){
      this.indiceModificaAdr = this.datiADR.indexOf(item)
      this.modificaAdr = true;
      this.codiceOnuInserito = item.tadonu;
      this.classeADRInserita = item.tadcls;
      this.kgADRInseriti = item.pesokg;
      this.aggiungiADR = true;
    },
    deleteItem (item) {
      const index = this.MisureBancali.indexOf(item)
      this.MisureBancali.splice(index, 1)
      
      this.lunghezza = 0;
      this.misuraSelezionata = {value : 0};
      this.misuraScelta = 0;
      this.MisureBancali.forEach(el=>{
          
          if(Number(el.mislun) > Number(this.lunghezza) && Number(el.mislun) > 200){
              this.lunghezza = el.mislun;
              this.misuraSelezionata = {value : 1};
              this.misuraScelta = 1;
          }
          if(Number(el.misalt) > Number(this.lunghezza) && Number(el.misalt) > 200){
              this.lunghezza = el.misalt;
              this.misuraSelezionata = {value : 2};
              this.misuraScelta = 2;
          }
          if(Number(el.mislar) > Number(this.lunghezza) && Number(el.mislar) > 200){
              this.lunghezza = el.mislar;
              this.misuraSelezionata = {value : 1};
              this.misuraScelta = 1;
          }
      });
      
      
    },
    deleteAdr (item) {
      const index = this.datiADR.indexOf(item)
      this.datiADR.splice(index, 1)
    },
    CheckMisure(){
      var voltot = 0.0;
      var pesotot = 0;
      var coltot = 0;
      var errore = "";
      this.MisureBancali.forEach(el=>{
        voltot += Math.round(((Number(el.mislun) / 100) * (Number(el.mislar) / 100) * (Number(el.misalt) / 100) * Number(el.miscll)) * 100)/100;
        var mis = 0.0;
        if(typeof el.mispes == 'string') {
          mis = Number(el.mispes.replace(",","."))
        } else {
          mis = el.mispes
        }
        pesotot +=  Math.round(mis * Number(el.miscll)*10)/10;
        coltot += Number(el.miscll);
      })
      pesotot = (Math.round(pesotot * 10))/10;
      var pesotemp = 0;
      if(this.peso===undefined || this.peso===null || this.peso==="") {
        pesotemp = 0;
      } else {
        if(typeof this.peso == 'string') {
          pesotemp = Number(this.peso.replace(",","."));
        } else {
          pesotemp = this.peso;
        }
        //pesotemp = pesotemp;
        pesotemp = (Math.round(pesotemp*10))/10;
      }
      if(this.numeroColli === null || this.numeroColli === undefined || this.numeroColli === "0" || this.numeroColli === "")
        this.numeroColli = 0;
      if(this.numeroColli !== 0 && Number(this.numeroColli) !== coltot){
        errore += "- Il Numero di colli indicato non corrisponde a quello calcolato nel dettaglio colli, svuota il campo Numero colli totale e ricalcola il totale o correggi il dettaglio colli <br>"
      }
      if (errore === ""){
        voltot = (Math.round(voltot*100)/100);
        this.numeroColli = coltot;
        this.peso = pesotot;
        this.volume = voltot;
      }
      return errore;

    },
    Calcola(){
      
      this.volumeTotale = 0;
      this.pesoTotale = 0;
      //this.numeroColli = 0;
      this.MisureBancali.forEach(el=>{
        this.volumeTotale += Math.round(((Number(el.mislun)  * Number(el.mislar)  * Number(el.misalt)  * Number(el.miscll))/1000000) *100) / 100;
        this.pesoTotale += Math.round(Number(el.mispes) * Number(el.miscll)*10)/10;
      })
      this.volumeTotale = Number(this.volumeTotale.toFixed(2));
      this.pesoTotale = Number(this.pesoTotale.toFixed(1));
      this.erroreDettaglio = this.CheckMisure();
        if(this.erroreDettaglio !== ""){
          this.erroreDettaglioColli = true;
        }
        else{
          this.volume = this.volumeTotale;
          this.peso = this.pesoTotale;
        }
    },
    CheckObbligoDettaglio(){
            axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/BOL-DETTMISURE").
            then(res=> {
                this.obbligoDettaglio = res.data;
                this.CheckObbligoVolume();
            });
    },
    CheckObbligoVolume(){
            axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/OBBLIGO-VOLUMEBOL").
            then(res=> {
                this.obbligoVolume = res.data;
                this.CheckModificaBolleStampate();
            });
    },
    CheckModificaBolleStampate(){
      axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/MOD-SLLISTA").
            then(res=> {
                this.modificaBolleStampate = res.data;
                this.CheckObbligoDettaglioPeso();
            });
    },
    CheckObbligoDettaglioPeso(){
            axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/PESO-OBBLIGODETBOL").
            then(res=> {
              if(res.data !== "" && res.data !== undefined && res.data !== null) 
                this.pesoPerDettaglioColli = Number(res.data);
              else
                this.pesoPerDettaglioColli = 999999999999;
              if(this.numeroSpedizione !== 0 && this.numeroSpedizione !== "0"){
                //console.log("stato : " + this.statoSpedizione);
                //console.log("valore : " + this.modificaBolleStampate);
                if(this.statoSpedizione !== "1" && this.statoSpedizione !== "-1" ){
                  if(this.statoSpedizione === "2" && this.modificaBolleStampate === 1 ){
                    this.readonly = false;
                  }
                  else{
                    this.readonly = true;
                    this.disable = true;
                  }
                }
                this.CaricaDati();
              }
              else{
                this.overlay = false;
              }
              this.overlay = false;
            });
    },
    GetMisura(event){
      this.misuraScelta = event;
    },
    GetDisposizioni1(event){
      this.dispo1Scelta = event;
      if(this.elencoADR[event] === 1){
        this.mostraADR = true;
      }
      else{
        this.mostraADR = false;
      }
      if(this.elencoPIANO[event] === 1){
        this.mostraPiano = true;
      }
      else{
        this.mostraPiano = false;
      }
      
    },
    GetDisposizioni2(event){
      this.dispo2Scelta = event;
      if(this.elencoADR[event] === 1){
        this.mostraADR = true;
      }
      else{
        this.mostraADR = false;
      }
      if(this.elencoPIANO[event] === 1){
        this.mostraPiano = true;
      }
      else{
        this.mostraPiano = false;
      }
      
    },
    
    GetServizioAggiuntivo(event){
      if(event != null)
        this.servizioScelto = event;
      if(this.elencoADR[event] === 1){
        this.mostraADR = true;
      }
      else{
        this.mostraADR = false;
      }
      if(this.elencoPIANO[event] === 1){
        this.mostraPiano = true;
      }
      else{
        this.mostraPiano = false;
      }
    },
    Validate(){

      var regexEmail = /^(([^\'<>()\[\]\\.,;:\s@"]+(\.[^\'<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
      this.overlay = true;
      this.errore = "";
      if(this.import === null || this.import === undefined || this.import === "")
        this.import = 0;
      if(this.volume === "" || this.volume === null || this.volume === undefined || this.volume === "0")
        this.volume = 0;
      if(this.numeroColli === null || this.numeroColli === undefined || this.numeroColli === "0" || this.numeroColli === "")
        this.numeroColli = 0;
      if(this.peso === "" || this.peso === undefined || this.peso === null || this.peso === "0")
        this.peso = 0;
      if(this.lunghezza === "" || this.lunghezza === undefined || this.lunghezza === null || this.lunghezza === "0")
        this.lunghezza = 0;
      if(this.contrassegno === "" || this.contrassegno === undefined || this.contrassegno === null || this.contrassegno === "0")
        this.contrassegno = 0;
      if(this.valoreMerce === "" || this.valoreMerce === undefined || this.valoreMerce === null || this.valoreMerce === "0")
        this.valoreMerce = 0;

      if(this.oreAMattino.trim() === '' || this.oreAMattino === null || this.oreAMattino === undefined) {
        this.oreAMattino = "";
      }
      if(this.oreCMattino.trim() ==='' || this.oreCMattino===null || this.oreCMattino===undefined) {
        this.oreCMattino="";
      }
      if(this.oraAPomeriggio.trim() ==='' || this.oraAPomeriggio === null || this.oraAPomeriggio === undefined) {
        this.oraAPomeriggio="";
      }
      if(this.oraCPomeriggio.trim() === '' || this.oraCPomeriggio === null || this.oraCPomeriggio === undefined) {
        this.oraCPomeriggio="";
      }
      if(this.minutiAMattino.trim() === '' || this.minutiAMattino === null || this.minutiAMattino === undefined) {
        this.minutiAMattino="";
      }
      if(this.minutiCMattino.trim() === '' || this.minutiCMattino === null || this.minutiCMattino === undefined) {
        this.minutiCMattino="";
      }
      if(this.minutiAPomeriggio.trim() === '' || this.minutiAPomeriggio === null || this.minutiAPomeriggio === undefined) {
        this.minutiAPomeriggio="";
      }
      if(this.minutiCPomeriggio.trim() === '' || this.minutiCPomeriggio === null || this.minutiCPomeriggio === undefined) {
        this.minutiCPomeriggio="";
      }
      if(this.indirizzoMailDestinatario === "" || this.indirizzoMailDestinatario === null || this.indirizzoMailDestinatario === undefined){
        this.indirizzoMailDestinatario = "";
      }
      if(this.indirizzoMailDestinatario.trim() !== ""){
        var listaMail = this.indirizzoMailDestinatario.split(";");
        if(listaMail.length > 3){
          this.errore += "-E' possibile inserire un massimo di 3 mail per l'invio del link al tracking separati dal carattere ';'. </br>";
        }
        else{
            var error = false;
            listaMail.forEach(el=>{
              var resultMail = el.trim().match(regexEmail);
            if(resultMail === null){
              error = true;
            }
          })
          if(error){
            this.errore += "-Uno o più indirizzi email inseriti per l'invio del link al tracking non è valido. </br>";
          }
        }
      }
      if(!this.ElencoDisposizioni1.includes(this.dispo1Scelta.trim()))
        this.errore += "- Selezionare una disposizione 1 valida</br>";
      if(!this.ElencoDisposizioni2.includes(this.dispo2Scelta.trim()))
        this.errore += "- Selezionare una disposizione 2 valida</br>";
      if(this.dispo1Scelta != " " && (this.dispo1Scelta == this.dispo2Scelta))
        this.errore += "- Non è possibile selezionare più volte la stessa disposizione</br>";
      if((this.dispo1Scelta == "E" || this.dispo2Scelta == "E") && this.preavvisare )
        this.errore += "- Scegliendo il servizio Espresso non è possibile indicare un preavviso telefonico </br>";
      //Controllo che negli orari non ci siano caratteri non numerici
      if(this.oreAMattino != ""){
        var regexNum = /[^0-99]/g;
        var resultOMattino = this.oreAMattino.match(regexNum);
        if(resultOMattino !== null){
          this.errore += "- Non è possibile inserire caratteri non numerici per l'ora di apertura mattino </br>";
        }
      }
      if(this.oreCMattino != ""){
        var regexNum = /[^0-99]/g;
        var resultCMattino = this.oreCMattino.match(regexNum);
        if(resultCMattino !== null){
          this.errore += "- Non è possibile inserire caratteri non numerici per l'ora di chiusura mattino </br>";
        }
      }
      if(this.oraAPomeriggio != ""){
        var regexNum = /[^0-99]/g;
        var resultAPom = this.oraAPomeriggio.match(regexNum);
        if(resultAPom !== null){
          this.errore += "- Non è possibile inserire caratteri non numerici per l'ora di apertura pomeriggio </br>";
        }
      }
      if(this.oraCPomeriggio != ""){
        var regexNum = /[^0-99]/g;
        var resultCPom = this.oraCPomeriggio.match(regexNum);
        if(resultCPom !== null){
          this.errore += "- Non è possibile inserire caratteri non numerici per l'ora di chiusura pomeriggio </br>";
        }
      }
      if(this.minutiAMattino != ""){
        var regexNum = /[^0-99]/g;
        var resultAMmatt = this.minutiAMattino.match(regexNum);
        if(resultAMmatt !== null){
          this.errore += "- Non è possibile inserire caratteri non numerici per i minuti di apertura mattino </br>";
        }
      }
      if(this.minutiCMattino != ""){
        var regexNum = /[^0-99]/g;
        var resultCMmatt = this.minutiCMattino.match(regexNum);
        if(resultCMmatt !== null){
          this.errore += "- Non è possibile inserire caratteri non numerici per i minuti di chiusura mattino </br>";
        }
      }
      if(this.minutiAPomeriggio != ""){
        var regexNum = /[^0-99]/g;
        var resultAPpom = this.minutiAPomeriggio.match(regexNum);
        if(resultAPpom !== null){
          this.errore += "- Non è possibile inserire caratteri non numerici per i minuti di apertura pomeriggio </br>";
        }
      }
      if(this.minutiCPomeriggio != ""){
        var regexNum = /[^0-99]/g;
        var resultCPpom = this.minutiCPomeriggio.match(regexNum);
        if(resultCPpom !== null){
          this.errore += "- Non è possibile inserire caratteri non numerici per i minuti di chiusura pomeriggio </br>";
        }
      }
      var a = this.capDestinatario;
      var trovato = false;
      if(a in this.$store.state.list_cappario ){
      this.$store.state.list_cappario[a].forEach(el=> {
          console.log(el.trploc.replace("'", "’").toUpperCase().trim());
          console.log(this.localitaDestinatario.toUpperCase().replace("`","’" ).trim());
          if(el.trploc.replace("'", "’").toUpperCase().trim() === this.localitaDestinatario.toUpperCase().replace("`", "’").replace("'", "’").trim()){
            this.provinciaDestinatario = el.trpprv;
            trovato = true;
          }
      });
      }
      //Controllo che i campi float non contengano più volte il punto
      // if(Number(this.lunghezza) > 999){
      //   this.errore += "- Non è possibile inserire una lunghezza maggiore di 999 centimetri </br>";
      // }

      if(trovato === false){
        this.errore += " - Non è stato possibile associare il cap e la località inseriti </br>";
      }

      var regx = /[a-zA-Z]/g;
      var result_ind = this.indirizzoDestinatario.match(regx);
      if(this.indirizzoDestinatario.trim().length < 4 || result_ind === null){
        this.errore += "- L'indirizzo deve contenere almeno 5 caratteri di cui almeno 1 carattere NON numerico</br>";
      }
      var patt = /[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]/g;
      var result_rags = this.ragioneSocialeDestinatario.match(patt);
      var result_ind = this.indirizzoDestinatario.match(patt);
      if(result_rags != null)
        this.errore += " - Non è possibile inserire un numero telefonico all'interno della ragione sociale del destinatario</br>";
      if(result_ind != null)
        this.errore += " - Non è possibile inserire un numero telefonico all'interno dell' indirizzo del destinatario </br>";
      if(this.civico === undefined || this.civico === null)
        this.civico = "";
      if((this.civico === "" || this.civico === undefined || this.civico === null ) && Number(this.import) === 0){
        this.errore += " - E' obbligatorio indicare il numero civico</br>";
      }
      this.giorniChiusura = "";
      this.giorniChiusura += this.CalcolaGiorniChiusura(this.lunedi);
      this.giorniChiusura += this.CalcolaGiorniChiusura(this.martedi);
      this.giorniChiusura += this.CalcolaGiorniChiusura(this.mercoledi);
      this.giorniChiusura += this.CalcolaGiorniChiusura(this.giovedi);
      this.giorniChiusura += this.CalcolaGiorniChiusura(this.venerdi);
      
      // if((this.minutiAPomeriggio.trim() !== "" || this.minutiCPomeriggio.trim() !== "" || this.minutiCMattino.trim() !== "" || this.minutiAMattino.trim() !== "") &&
      // (Number(this.minutiAPomeriggio) < 0 || Number(this.minutiCPomeriggio) < 0 || Number(this.minutiCMattino) < 0 || Number(this.minutiAMattino) < 0) &&
      // (Number(this.minutiAPomeriggio) > 59 || Number(this.minutiCPomeriggio) > 59 || Number(this.minutiCMattino) > 59 || Number(this.minutiAMattino) > 59) ){
      //   this.errore += " - Gli orari pomeridiani devono essere compresi tra le 13.01 e le 20.59 </br>";
      // }
      //  if((this.oreCMattino.trim() !== "" || this.oreAMattino.trim() != "") && (this.oreCMattino !== "00" || this.oreAMattino != "00" )&& (Number(this.oreAMattino) < 7 || Number(this.oreCMattino)>12 || Number(this.oreAMattino) > 12 || Number(this.oreCMattino)<7 || Number(this.oreCMattino) < Number(this.oreAMattino)) ){
      //   this.errore += " - Gli orari della mattina devono essere compresi tra le 7 e le 12.59. L'orario di chiusura non può essere precedente a quello di apertura </br>";
      // }
      // if((this.oraCPomeriggio.trim() !== "" || this.oraAPomeriggio.trim() != "") && (this.oraCPomeriggio !== "00" || this.oraAPomeriggio != "00") && (Number(this.oraAPomeriggio) < 13 && Number(this.minutiAPomeriggio) < 1|| Number(this.oraCPomeriggio)>20 || Number(this.oraAPomeriggio) > 20 || (Number(this.oraCPomeriggio) < 13 && Number(this.minutiCPomeriggio) < 1)|| Number(this.oraAPomeriggio) > Number(this.oraCPomeriggio)) ){
      //   this.errore += " - Gli orari pomeridiani devono essere compresi tra le 13.01 e le 20.59 </br>";
      // }
      if(this.telefonoPreavviso === null || this.telefonoPreavviso === undefined){
        this.telefonoPreavviso = "";
      }
      
      if(Number(this.oreAMattino) === 0 && Number(this.minutiAMattino) === 0){
        this.oreAMattino = "";
        this.minutiAMattino = "";
      }
      if(Number(this.oreCMattino) === 0 && Number(this.minutiCMattino) === 0){
        this.oreCMattino = "";
        this.minutiCMattino = "";
      }
      if(Number(this.oraAPomeriggio) === 0 && Number(this.minutiAPomeriggio) === 0){
        this.oraAPomeriggio = "";
        this.minutiAPomeriggio = "";
      }
      if(Number(this.oraCPomeriggio) === 0 && Number(this.minutiCPomeriggio) === 0){
        this.oraCPomeriggio = "";
        this.minutiCPomeriggio = "";
      }
      // 0- che siano degli orari formalmente validi (ora tra le 00 e le 24 e minuti da 0 a 59)
      if(Number(this.oreAMattino) < 0 || Number(this.oreAMattino) > 24 || Number(this.oreCMattino) < 0 || Number(this.oreCMattino) > 24 ||
          Number(this.oreAPomeriggio) <0 || Number(this.oreAPomeriggio) > 24 || Number(this.oraCPomeriggio) < 0 || Number(this.oraCPomeriggio) > 24){
            this.errore += " - Verificare il formato dell'orario (le ore devono essere comprese tra 00 e 24) </br>";
          }
      if(Number(this.minutiAMattino) < 0 || Number(this.minutiAMattino) > 59 || Number(this.minutiCMattino) < 0 || Number(this.minutiCMattino) > 59||
        Number(this.minutiAPomeriggio) < 0 || Number(this.minutiAPomeriggio) > 59 || Number(this.minutiCPomeriggio) < 0 || Number(this.minutiCPomeriggio) > 59){
          this.errore += " - Verificare il formato dell'orario (i minuti devono essere compresi tra 00 e 59) </br>";
        }

      // 1- Apertura mattina > 06:30 e minore delle 13:01
      if(this.oreAMattino.trim() !== "" || this.minutiAMattino.trim() != ""){
        if(Number(this.oreAMattino) < 6 || (Number(this.oreAMattino) === 6 && Number(this.minutiAMattino) < 30) || Number(this.oreAMattino) > 13 ||  (Number(this.oreAMattino) === 13 && Number(this.minutiAMattino) > 0))
        {
          this.errore += " - L'orario di apertura della mattina deve essere compreso tra le 06:30 e le 13:00 </br>";
        }
      }
      // 2 - Chiusura mattina > 06:30 e minore delle 13:01
      if(this.oreCMattino.trim() !== "" || this.minutiCMattino.trim() !== ""){
        if(Number(this.oreCMattino) < 6 || (Number(this.oreCMattino) === 6 && Number(this.minutiCMattino) < 30) || Number(this.oreCMattino) > 13 || (Number(this.oreCMattino) === 13 && Number(this.minutiCMattino) > 0)){
          this.errore += " - L'orario di chiusura della mattina deve essere compreso tra le 06:30 e le 13:00 </br>";
        }
      }
      // 3 - Chiusura mattina > apertura mattina
      if((this.oreAMattino.trim() !== "" || this.minutiAMattino.trim() != "" && this.oreCMattino.trim() !== "" || this.minutiCMattino.trim() !== "") && (Number(this.oreCMattino) < Number(this.oreAMattino) || (Number(this.oreCMattino) === Number(this.oreAMattino) && Number(this.minutiCMattino) <= Number(this.minutiAMattino)))){
        this.errore += " - L'orario di chiusura della mattina deve essere successivo all'orario di apertura. </br>";
      }
      // 4- Apertura pomeriggio > 13:01 e minore delle 19:30
      if(this.oraAPomeriggio.trim() !== "" || this.minutiAPomeriggio.trim() != ""){
        if(Number(this.oraAPomeriggio) < 13 || (Number(this.oraAPomeriggio) === 13 && Number(this.minutiAPomeriggio) < 1) || Number(this.oraAPomeriggio) > 19 || (Number(this.oraAPomeriggio) === 19 && Number(this.minutiAPomeriggio) > 30)){
          this.errore += " - L'orario di apertura del pomeriggio deve essere compreso tra le 13:01 e le 19:30 </br>";
        }
      }
      //5 - Chiusura pomeriggio > 13:01 e minore delle 19:30
      if(this.oraCPomeriggio.trim() !== "" || this.minutiCPomeriggio.trim() != ""){
        if(Number(this.oraCPomeriggio) < 13 || (Number(this.oraCPomeriggio) === 13 && Number(this.minutiCPomeriggio) < 1) || Number(this.oraCPomeriggio) > 19 || (Number(this.oraCPomeriggio) === 19 && Number(this.minutiCPomeriggio) > 30)){
          this.errore += " - L'orario di chiusura del pomeriggio deve essere compreso tra le 13:01 e le 19:30 </br>";
        }
      }
      // 6 - Chiusura pomeriggio > apertura pomeriggio
      if((this.oraAPomeriggio.trim() !== "" || this.minutiAPomeriggio.trim() != "" && this.oraCPomeriggio.trim() !== "" || this.minutiCPomeriggio.trim() !== "") && (Number(this.oraCPomeriggio) < Number(this.oraAPomeriggio) || (Number(this.oraCPomeriggio) === Number(this.oraAPomeriggio) && Number(this.minutiCPomeriggio) <= Number(this.minutiAPomeriggio)))){
        this.errore += " - L'orario di chiusura del pomeriggio deve essere successivo all'orario di apertura. </br>";
      }
      //nuovi controlli sui numeri di telefono richiesti da Luca Dozio:
      if(this.preavvisare && (this.telefonoPreavviso.trim() === "" || this.telefonoPreavviso === undefined || this.telefonoPreavviso === null )){
        this.errore += " - E' obbligatorio indicare il numero di telefono per il preavviso </br>";
      }
      //Verifico che nel telefono del preavviso siano presenti almeno 6 numeri.
      // if(this.preavvisare && this.telefonoPreavviso.replace("+", "").replace(" ","").trim().length < 6 ){
      //   this.errore += "- Il numero di telefono per il preavviso deve contenere almeno 6 numeri </br>";
      // }
      // else if(this.preavvisare && this.telefonoPreavviso.replace("+", "").replace(" ","").trim().length > 5){
      //   var findNum = /[0-99]/g;
      //   var resultTelefono = this.telefonoPreavviso.match(findNum);
      //   if(resultTelefono !== null){
      //     if(resultTelefono.length < 6 && !this.telefonoPreavviso.includes("@")){
      //       this.errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri.</br>";
      //     }
      //   }
      //   else{
      //     if(!this.telefonoPreavviso.includes("@"))
      //       this.errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri. </br>";
      //   }
      // }
      if(this.ragioneSocialeDestinatario.trim().length < 5){
        this.errore += " - La ragione sociale del destinatario deve essere lunga almeno 5 caratteri </br>";
      }
      if(this.indirizzoDestinatario.length < 3){
        this.errore += " - L'indirizzo del destinatario non può essere più corto di 3 caratteri </br>";
      }
      if(this.localitaDestinatario.length < 3){
        this.errore += " - La località del destinatario non può essere più corto di 3 caratteri </br>";
      }
      if(this.provinciaDestinatario.length !== 2){
        this.errore += " - Inserire una provincia valida </br>";
      }
      if(this.capDestinatario.length !== 5){
        this.errore += " - Inserire un cap valido </br>";
      }
      if(this.emailDestinatarioTracking && (this.indirizzoMailDestinatario === "" || this.indirizzoMailDestinatario === undefined || this.indirizzoMailDestinatario === null )){
        this.errore += " - E' obbligatorio indicare la mail del destinatario per il tracking </br>";
      }
      
      if((this.obbligoDettaglio === 1 || this.obbligoDettaglio === "1") && (this.MisureBancali.length === 0 || Number(this.numeroColli) < 1 )){
        this.errore += " - E' obbligatorio inserire il numero dei colli con i relativi dettagli </br>";
      }
      if(this.mostraADR === true && this.datiADR.length < 1 )
        this.errore += "- Specificare almeno un codice onu valido per la disposizione ADR.</br>";
      if(this.concordataTassativa===null || this.concordataTassativa ===undefined) { this.concordataTassativa=false; }
      if(this.tassativaSelezionata.value===null || this.tassativaSelezionata.value ===undefined) { this.tassativaSelezionata.value=null; }
      if(this.data_partenza===null || this.data_partenza===undefined) { this.data_partenza=""; }
      if(this.concordataTassativa && (this.tassativaSelezionata.value === null || this.data_partenza === "")){
        this.errore += "- Per la consegna concordata / tassativa è necessario specificare il tipo tassativa e una data </br>";
      }
      var decimali = "";
      decimali = this.contrassegno.toString().split(".");
      if(decimali.length > 1)
      {
        if(decimali[1].toString().length > 2)
        {
          this.errore += " - Non è possibile inserire più di 2 decimali per l'importo del contrassegno </br> ";
        }
      }
      var decimaliPeso = "";
      decimaliPeso = this.peso.toString().split(".");
      if(decimaliPeso.length > 1)
      {
        if(decimaliPeso[1].toString().length > 1)
        {
          this.errore += " - Non è possibile inserire più di 1 decimale per il valore del peso </br> ";
        }
      }
      if(Number(this.contrassegno) !== 0 && (this.tipoIncasso == "" || this.tipoIncasso.toString() == " ")){
        this.errore += " - Inserendo un contrassegno è obbligatorio specificare il tipo incasso. </br>";
      }
      if(!(this.tipoIncasso in this.elencoIncassi)){
        this.errore += " - Selezionare un tipo incasso valido </br>";
      }      
      if(Number(this.contrassegno) !== 0 && (this.tipoIncasso !== " " && this.tipoIncasso.toString() !== " " )&& (Number(this.contrassegno) > Number(this.contrMaxValue) || Number(this.contrassegno) < Number(this.contrMinValue) )){
        this.errore += " - Il valore per il contrassegno non è valido. Gli importi, per il tipo incasso selezionato, possono essere tra " +this.contrMinValue+ "€ e " + this.contrMaxValue+ "€ </br>";
      }
      
      if(Number(this.peso)  === 0 || Number(this.peso) < 0 ){
        this.errore += " - Inserire un peso valido </br>";
      }
      if(this.numeroColli === null || this.numeroColli === undefined || this.numeroColli === "0" || this.numeroColli === "")
        this.numeroColli = 0;
      if(Number(this.numeroColli) <1){
        this.errore += " - Inserire un numero di colli valido </br>";
      }
      if(Number(this.epalDaRendere) > Number(this.numeroColli)){
        this.errore += " - Non è possibile inserire un numero di Epal a rendere maggiore del numero colli inserito </br>";
      }
      if(this.lunedi === 0){
        this.errore += " - Selezionare un'opzione per la chiusura del lunedì </br>";
      }
      if(this.martedi === 0){
        this.errore += " - Selezionare un'opzione per la chiusura del martedì </br>";
      }
      if(this.mercoledi === 0){
        this.errore += " - Selezionare un'opzione per la chiusura del mercoledì </br>";
      }
      if(this.giovedi === 0){
        this.errore += " - Selezionare un'opzione per la chiusura del giovedì </br>";
      }
      if(this.venerdi === 0){
        this.errore += " - Selezionare un'opzione per la chiusura del venerdì </br>";
      }
      if(this.sceltaEpal === 1 && Number(this.epalDaRendere) <1){
        this.errore += " - E' obbligatorio inserire il numero di epal a rendere </br>";
      }
      if(this.obbligoVolume === 1 && (Number(this.volume) === 0 || this.volume === "" || this.volume === undefined || this.volume === null)){
        this.errore += " - E' obbligatorio inserire il volume </br>";
      }
      if(Number(this.peso) > (Number(this.pesoPerDettaglioColli) - 1) && (!this.dettaglioColli || this.MisureBancali.length < 1)){
        this.errore += " - Per il peso inserito è obbligatorio specificare il dettaglio colli </br>";
      }
      if(Number(this.preavvisoObbligatorio === 1) && (this.preavvisare === false || this.telefonoPreavviso.trim() === "" || this.telefonoPreavviso === undefined) ){
        this.errore += " - E' obbligatorio inserire il preavviso per il tipo incasso selezionato </br>";
      }
      if(this.mostraPiano && (this.pianoConsegna === ""  || this.pianoConsegna === null || this.pianoConsegna === undefined)){
        this.errore += " - E' obbligatorio inserire il piano di consegna per il servizio di consegna al piano </br>";
      }
      var decimaliVolume = "";
      decimaliVolume = this.volume.toString().split(".");
      if(decimaliVolume.length > 1){
        if(decimaliVolume[1].toString().length > 2){
          this.errore += " - Non è possibile inserire più di 2 decimali per il valore del volume </br>"
        }
      }
      if(Number(this.volume)>100) {
        this.errore += " - Il volume non può essere maggiore di 100 m.cubi </br>";
      }
      if(Number(this.peso) > 33000){
        this.errore += " - Il peso non può superare i 33000 Kg. </br>";
      }
      if(this.MisureBancali.length > 0){
        var misuraMaggioreTemp = 0;
        var maggiore = false;
        var lunghezzaTemp = 0;
        this.MisureBancali.forEach(el=>{
          if(Number(el.mislun) > Number(lunghezzaTemp)){
              misuraMaggioreTemp = 1;
              lunghezzaTemp = el.mislun;
              if(Number(el.mislun) > 200)
                maggiore = true;
          }
          if(Number(el.misalt) > Number(lunghezzaTemp) ){
              misuraMaggioreTemp = 2;
              lunghezzaTemp = el.misalt;
              if(Number(el.misalt) > 200)
                maggiore = true;
          }
          if(Number(el.mislar) > Number(lunghezzaTemp) ){
              misuraMaggioreTemp = 1;
              lunghezzaTemp = el.mislar;
              if(Number(el.mislar) > 200)
                maggiore = true;
          }
        });

        if(maggiore == false && this.misuraScelta != 0)
        {
          if(misuraMaggioreTemp != this.misuraScelta)
            this.errore += "La misura maggiore scelta non è coerente con le misure inserite.</br>";
        }
        else if(maggiore && this.misuraScelta != misuraMaggioreTemp)
          this.errore += "La misura maggiore scelta non è coerente con le misure inserite.</br>";

      }
      // if( this.concordataTassativa && (this.data_partenza === "1900-01-01" || this.data_partenza === "0001-01-01" || this.data_partenza === "")){
      //   this.errore += " - La data concordata / tassativa non è valida </br>";
      // }
      if(this.errore === ""){
        //Mi calcolo peso, volume e colli totali del dettaglio, se presente.
        if(this.MisureBancali.length > 0){
          this.volume = 0;
          this.peso = 0;
          this.ColliTotali = 0;
          this.MisureBancali.forEach(el=> {
            this.ColliTotali += Number(el.miscll);
            this.volume += Math.round(((Number(el.mislun) / 100) * (Number(el.mislar) / 100) * (Number(el.misalt) / 100) * Number(el.miscll)) * 100)/100;
            this.peso += Math.round(el.mispes * Number(el.miscll)*10)/10;
          })
          this.volume = Number(this.volume.toFixed(2));
          this.peso = Number(this.peso.toFixed(1));
          
        }
        if(this.numeroColli === null || this.numeroColli === undefined || this.numeroColli === "0" || this.numeroColli === "")
          this.numeroColli = 0;
        if(Number(this.ColliTotali) > 0 && Number(this.ColliTotali) != Number(this.numeroColli) && this.dettaglioColli === true){
            this.errore += " - Il totale dei colli inseriti nel dettaglio non corrisponde al numero di colli indicati nella compilazione del form </br>";
            this.overlay = false;
            this.erroreValidazione = true;
        }
        if(this.peso === null || this.peso === undefined || this.peso === "0" || this.peso === "")
          this.peso = 0
        if(Number(this.peso) === 0 || Number(this.peso) > 33000){
          this.errore += " - Il peso totale inserito nel dettaglio non può essere 0 o maggiore di 33000 Kg. </br>";
          this.overlay = false;
          this.erroreValidazione = true;
        }
        if(this.volume === null || this.volume === undefined || this.volume === "0" || this.volume === "")
          this.volume = 0
        if(Number(this.volume) === 0 && this.obbligoVolume === 1){
          this.errore += " - Il volume totale inserito nel dettaglio non può essere 0 m.cubi</br>";
          this.overlay = false;
          this.erroreValidazione = true;
        }
        if(Number(this.volume) > 100){
          this.errore += " - Il volume totale inserito nel dettaglio non può essere maggiore di 100 m.cubi</br>";
          this.overlay = false;
          this.erroreValidazione = true;
        }
      if (this.errore === ""){
        if(this.data_partenza !== "" && this.data_partenza !== "1900-01-01" && this.data_partenza !== "0001-01-01" && this.concordataTassativa){
              this.CheckResa();
            }
        else{
          this.Submit();
        }
      }
      }
      else{
        this.overlay = false;
        this.erroreValidazione = true;
      }
    },
    CalcolaGiorniChiusura(giorno){
      if(giorno === 1){
        return " ";
      }
      else if(giorno === 2){
        return "M";
      }
      else if(giorno === 3){
        return "P";
      }
      else if(giorno === 4){
        return "T";
      }
    },
    Reset(){
      this.tassativaSelezionata = {value: -1};
      this.collante = "";
      this.ragioneSocialeDestinatario = "";
      this.localitaDestinatario = "";
      this.indirizzoDestinatario = "";
      this.provinciaDestinatario = "";
      this.capDestinatario = "";
      this.riferimentoDdt = "";
      this.preavvisare = false;
      this.telefonoPreavviso = "";
      this.emailMittenteTracking = 0;
      this.emailDestinatarioTracking = 0;
      this.indirizzoMailDestinatario = "";
      this.numeroColli = 0;
      this.peso = 0;
      this.dettaglioColli = false;
      this.MisureBancali = [];
      this.volume = 0;
      this.lunghezza = 0;
      this.misuraSelezionata = {value: 0};
      this.contrassegno = 0;
      this.valoreMerce = 0;
      this.scansioneLDV = false;
      this.centroStorico = false;
      this.concordataTassativa = false;
      this.lunedi = 1;
      this.martedi = 1;
      this.mercoledi = 1;
      this.giovedi = 1;
      this.venerdi = 1;
      this.sabato = 1;
      this.domenica = 1;
      this.oreAMattino = "";
      this.civico = "",
      this.import = "0",
      this.oreCMattino = "";
      this.minutiAMattino = "";
      this.minutiCMattino = "";
      this.oraAPomeriggio = "";
      this.oraCPomeriggio = "";
      this.minutiAPomeriggio = "";
      this.minutiCPomeriggio = "";
      this.dispo1Scelta = this.disposizioni1[0].value;
      this.dispo2Scelta = this.disposizioni2[0].value;
      this.dispo1Selezionata = {value: this.disposizioni1[0].value};
      this.dispo2Selezionata = {value: this.disposizioni2[0].value};
      this.servizioScelto = this.serviziAggiuntivi[0].value;
      this.servizioAggiuntivoSelezionato = {value: this.serviziAggiuntivi[0].value};
      this.datiADR = [];
      this.mostraADR = false;
      this.epalARendere = {value : 0};
      this.epalDaRendere = 0;
      this.sceltaEpal = 0;
      this.data_partenza = "";
      

    },
    Submit(){
      if(this.notsave === 1){
        this.overlay = false;
        this.dialogNotSave = true;
      }
      else{
        this.telefonoPreavviso = this.preavvisare?this.telefonoPreavviso:"";
        this.MisureBancali = this.dettaglioColli?this.MisureBancali:[];
        var pad="00";
        if(this.oreAMattino != '' && this.oreAMattino!=null && this.oreAMattino!=undefined) {
          this.oreAMattino=pad.substring(0,pad.length-this.oreAMattino.length)+this.oreAMattino;
        }
        if(this.oreCMattino!='' && this.oreCMattino!=null && this.oreCMattino!=undefined) {
          this.oreCMattino=pad.substring(0,pad.length-this.oreCMattino.length)+this.oreCMattino;
        }
        if(this.oraAPomeriggio!='' && this.oraAPomeriggio!=null && this.oraAPomeriggio!=undefined) {
          this.oraAPomeriggio=pad.substring(0,pad.length-this.oraAPomeriggio.length)+this.oraAPomeriggio;
        }
        if(this.oraCPomeriggio!='' && this.oraCPomeriggio!=null && this.oraCPomeriggio!=undefined) {
          this.oraCPomeriggio=pad.substring(0,pad.length-this.oraCPomeriggio.length)+this.oraCPomeriggio;
        }
        if(this.minutiAMattino!='' && this.minutiAMattino!=null && this.minutiAMattino!=undefined) {
          this.minutiAMattino=pad.substring(0,pad.length-this.minutiAMattino.length)+this.minutiAMattino;
        }
        if(this.minutiCMattino!='' && this.minutiCMattino!=null && this.minutiCMattino!=undefined) {
          this.minutiCMattino=pad.substring(0,pad.length-this.minutiCMattino.length)+this.minutiCMattino;
        }
        if(this.minutiAPomeriggio!='' && this.minutiAPomeriggio!=null && this.minutiAPomeriggio!=undefined) {
          this.minutiAPomeriggio=pad.substring(0,pad.length-this.minutiAPomeriggio.length)+this.minutiAPomeriggio;
        }
        if(this.minutiCPomeriggio!='' && this.minutiCPomeriggio!=null && this.minutiCPomeriggio!=undefined) {
          this.minutiCPomeriggio=pad.substring(0,pad.length-this.minutiCPomeriggio.length)+this.minutiCPomeriggio;
        }
        if(!this.modificaForm){
          var json ={
            numddt : this.riferimentoDdt.replace("'", "''"),
            desrag  : this.ragioneSocialeDestinatario.replace("'", "''"),
            desind : this.indirizzoDestinatario.replace("'", "''"),
            desloc : this.localitaDestinatario.replace("'", "''"),
            desciv : this.civico.replace("'", "''"),
            descap : this.capDestinatario.replace("'", "''"),
            desprv : this.provinciaDestinatario.replace("'", "''"),
            numcol : Number(this.numeroColli.toString().replace(",",".")),
            pesokg : Number(this.peso.toString().replace(",",".")),
            volmec : Number(this.volume.toString().replace(",",".")),
            lun200 : Number(this.lunghezza.toString().replace(",",".")),
            lun200mis : this.misuraScelta,
            valore : Number(this.valoreMerce.toString().replace(",", ".")),
            contra : Number(this.contrassegno.toString().replace(",",".")),
            tipinc : this.tipoIncasso,
            datCon : this.data_partenza,
            tipCon : this.tassativaSelezionata.value,
            dispo1 : this.dispo1Scelta,
            dispo2 : this.dispo2Scelta,
            pretel : this.telefonoPreavviso.replace("'", "''"),
            giochi : this.giorniChiusura,
            srvpre : this.preavvisare?1:0,
            collante: this.collante,
            notspe : this.notspe,
            stato : 1,
            fildes : "",
            gatdes : "",
            instrada : "",
            datdis : "",
            banren : this.epalDaRendere,
            segsta : "",
            maides : this.indirizzoMailDestinatario.replace("'", "''"),
            mailme : this.emailMittenteTracking?1:0,
            mailtu : this.emailDestinatarioTracking?1:0,
            sentme : 0,
            senttu : 0,
            insalt : "",
            numcon : 0,
            piacon : this.pianoConsegna,
            mitrag : "",
            mitind : "",
            mitloc : "",
            mitcap : "",
            mitprv : "",
            prenota : 0,
            detcol : this.dettaglioColli?1:0,
            orapma : this.oreAMattino + this.minutiAMattino,
            orchma : this.oreCMattino + this.minutiCMattino,
            orappo : this.oraAPomeriggio + this.minutiAPomeriggio,
            orchpo : this.oraCPomeriggio + this.minutiCPomeriggio,
            segeffsta : 0,
            seracc : this.servizioScelto,
            censto : this.centroStorico?1:0,
            tipprov : 0,
            palaper : "",
            pdccom : this.scansioneLDV?1:0,
            import: this.import
          };
          
          var J = {
            bolla: json,
            misure: this.MisureBancali,
          };
          axios.post(this.$store.state.servicePath + "/api/ArBolleSpes", J).
                then(res=> {
                    if(res.status === 200 && this.MisureBancali.length > 0){
                      var S = {
                        bolla: res.data,
                        misure: this.MisureBancali,
                        adr: this.datiADR,
                      }
                      axios.post(this.$store.state.servicePath + "/api/ArBolleDets", S).
                      then(res=> {
                        if(res.status === 200 && this.datiADR.length > 0){
                          axios.post(this.$store.state.servicePath + "/api/ArBolleAdrs", S).
                            then(res=> {
                              if(res.status === 200){
                                if(this.stampaImmediataA4 == 1){
                                  this.StampaEtichetteA4(S.bolla.numspe);
                                }
                                else if (this.stampaImmediata10 == 1){
                                  this.StampaEtichette10(S.bolla.numspe);
                                }
                                else{
                                  this.$router.push({ path: `/Bollettazione` });
                                }
                                
                              }
                            })
                            .catch(err =>{
                              this.overlay = false;
                              this.erroreResa = true;
                              this.messageResa = "SI SONO VERIFICATI ERRORI DURANTE IL SALVATAGGIO DELLA TUA SPEDIZIONE. CONTATTA L'ASSISTENZA SE IL PROBLEMA PERSISTE.";
                            });
                        }
                        else{
                          this.$router.push({ path: `/Bollettazione` });
                        }
                      })
                      .catch(err =>{
                        this.overlay = false;
                        this.erroreResa = true;
                        this.messageResa = "SI SONO VERIFICATI ERRORI DURANTE IL SALVATAGGIO DELLA TUA SPEDIZIONE. CONTATTA L'ASSISTENZA SE IL PROBLEMA PERSISTE.";
                      });
                      this.overlay = false;
                }
                else if(res.status === 200 && this.datiADR.length > 0){
                  var S = {
                        bolla: res.data,
                        misure: this.MisureBancali,
                        adr: this.datiADR,
                      }
                  axios.post(this.$store.state.servicePath + "/api/ArBolleAdrs", S)
                    .then(res=> {
                      if(res.status === 200){
                        if(this.stampaImmediataA4 == 1){
                          this.StampaEtichetteA4(S.bolla.numspe);
                        }
                        else if (this.stampaImmediata10 == 1){
                          this.StampaEtichette10(S.bolla.numspe);
                        }
                        else{
                          this.$router.push({ path: `/Bollettazione` });
                        }
                        
                      }
                    })
                    .catch(err =>{
                      this.overlay = false;
                      this.erroreResa = true;
                      this.messageResa = "SI SONO VERIFICATI ERRORI DURANTE IL SALVATAGGIO DELLA TUA SPEDIZIONE. CONTATTA L'ASSISTENZA SE IL PROBLEMA PERSISTE.";
                    });
                }
                else if (res.status !== 200){
                  this.overlay = false;
                  this.erroreResa = true;
                  this.messageResa = "SI SONO VERIFICATI ERRORI DURANTE IL SALVATAGGIO DELLA TUA SPEDIZIONE. CONTATTA L'ASSISTENZA SE IL PROBLEMA PERSISTE.";
                }
                else{
                  this.$router.push({ path: `/Bollettazione` });
                }
                })
                
                .catch(err =>{
                    this.overlay = false;
                    this.erroreResa = true;
                    this.messageResa = "SI SONO VERIFICATI ERRORI DURANTE IL SALVATAGGIO DELLA TUA SPEDIZIONE. CONTATTA L'ASSISTENZA SE IL PROBLEMA PERSISTE.";
          });
          
        }
        else{
          this.JsonModifica.bolla.numspe = this.numeroSpedizione.replace("'", "''");
          this.JsonModifica.bolla.collante = this.collante;
          this.JsonModifica.bolla.numddt = this.riferimentoDdt.replace("'", "''");
          this.JsonModifica.bolla.desrag  = this.ragioneSocialeDestinatario.replace("'", "''");
          this.JsonModifica.bolla.desind = this.indirizzoDestinatario.replace("'", "''");
          this.JsonModifica.bolla.import = this.import;
          this.JsonModifica.bolla.desciv = this.civico;
          this.JsonModifica.bolla.desloc = this.localitaDestinatario.replace("'", "''");
          this.JsonModifica.bolla.descap = this.capDestinatario.replace("'", "''");
          this.JsonModifica.bolla.desprv = this.provinciaDestinatario.replace("'", "''");
          this.JsonModifica.bolla.numcol = Number((this.numeroColli==null ? "0":this.numeroColli.toString().replace(",",".")));
          this.JsonModifica.bolla.pesokg = Number((this.peso==null ? "0":this.peso.toString().replace(",",".")));
          this.JsonModifica.bolla.volmec = Number((this.volume==null ? "0":this.volume.toString().replace(",",".")));
          this.JsonModifica.bolla.lun200 = Number((this.lunghezza==null ? "0":this.lunghezza.toString().replace(",",".")));
          this.JsonModifica.bolla.lun200mis = this.misuraScelta;
          this.JsonModifica.bolla.valore = Number((this.valoreMerce==null ? "0":this.valoreMerce.toString().replace(",",".")));
          this.JsonModifica.bolla.contra = Number((this.contrassegno==null ? "0":this.contrassegno.toString().replace(",",".")));
          this.JsonModifica.bolla.tipinc = this.tipoIncasso;
          this.JsonModifica.bolla.datCon = this.data_partenza;
          this.JsonModifica.bolla.tipCon = this.tassativaSelezionata.value;
          this.JsonModifica.bolla.dispo1 = this.dispo1Scelta;
          this.JsonModifica.bolla.dispo2 = this.dispo2Scelta;
          this.JsonModifica.bolla.pretel = this.telefonoPreavviso;
          this.JsonModifica.bolla.giochi = this.giorniChiusura;
          this.JsonModifica.bolla.srvpre = this.preavvisare?1:0;
          this.JsonModifica.bolla.notspe = this.notspe;
          this.JsonModifica.bolla.stato = this.statoSpedizione === "2"?this.statoSpedizione:1;
          this.JsonModifica.bolla.fildes = this.fildes;
          this.JsonModifica.bolla.gatdes = this.gatdes;
          this.JsonModifica.bolla.instrada = this.instrada;
          this.JsonModifica.bolla.datdis = this.datdis;
          this.JsonModifica.bolla.banren = this.epalDaRendere;
          this.JsonModifica.bolla.segsta = this.segsta;
          this.JsonModifica.bolla.maides = this.indirizzoMailDestinatario.replace("'", "''");
          this.JsonModifica.bolla.mailme = this.emailMittenteTracking?1:0;
          this.JsonModifica.bolla.mailtu = this.emailDestinatarioTracking?1:0;
          this.JsonModifica.bolla.sentme = 0;
          this.JsonModifica.bolla.senttu = 0;
          this.JsonModifica.bolla.insalt = this.insalt;
          this.JsonModifica.bolla.numcon = 0;
          this.JsonModifica.bolla.piacon = this.pianoConsegna;
          this.JsonModifica.bolla.mitrag = this.mitrag;
          this.JsonModifica.bolla.mitind = this.mitind;
          this.JsonModifica.bolla.mitloc = this.mitloc;
          this.JsonModifica.bolla.mitcap = this.mitcap;
          this.JsonModifica.bolla.mitprv = this.mitprv;
          this.JsonModifica.bolla.prenota = 0;
          this.JsonModifica.bolla.detcol = this.dettaglioColli?1:0;
          this.JsonModifica.bolla.orapma = this.oreAMattino + this.minutiAMattino;
          this.JsonModifica.bolla.orchma = this.oreCMattino + this.minutiCMattino;
          this.JsonModifica.bolla.orappo = this.oraAPomeriggio + this.minutiAPomeriggio;
          this.JsonModifica.bolla.orchpo = this.oraCPomeriggio + this.minutiCPomeriggio;
          this.JsonModifica.bolla.segeffsta = 0;
          this.JsonModifica.bolla.collante = this.collante;
          this.JsonModifica.bolla.seracc = this.servizioScelto;
          this.JsonModifica.bolla.censto = this.centroStorico?1:0;
          this.JsonModifica.bolla.tipprov = 0;
          this.JsonModifica.bolla.palaper = this.palaper;
          this.JsonModifica.bolla.pdccom = this.scansioneLDV?1:0;
          this.JsonModifica.misure = this.MisureBancali;
          this.JsonModifica.adr = this.datiADR;
          axios.put(this.$store.state.servicePath + "/api/ArBolleSpes/" + this.numeroSpedizione, this.JsonModifica).
                then(res=> {
                    if(res.status === 204){
                  if(this.stampaImmediataA4 == 1){
                    this.StampaEtichetteA4(this.numeroSpedizione);
                    
                  }
                  else if (this.stampaImmediata10 == 1){
                    this.StampaEtichette10(this.numeroSpedizione);
                    
                  }
                  else{
                    this.$router.push({ path: `/Bollettazione` });
                  }
                }
                })
                .catch(err =>{
                  this.overlay = false;
                    this.erroreResa = true;
                    this.messageResa = "SI SONO VERIFICATI ERRORI DURANTE IL SALVATAGGIO DELLA TUA SPEDIZIONE. CONTATTA L'ASSISTENZA SE IL PROBLEMA PERSISTE.";
          });
        }
      }
    },
    CaricaDati(){
      this.JsonModifica["bolla"] = {}
        axios.get(this.$store.state.servicePath + "/api/ArBolleSpes/" + this.numeroSpedizione).
            then(res=> {
                this.modificaForm = true;
                this.JsonModifica["bolla"] = res.data;
                //console.log(this.JsonModifica);
                this.scansioneLDV = res.data.pdccom==="1"?true:false;
                this.collante = res.data.collante;
                this.ragioneSocialeDestinatario = res.data.desrag!==null?res.data.desrag.replace("''", "'"):"";
                this.indirizzoDestinatario = res.data.desind!==null?res.data.desind.replace("''", "'"):"";
                this.civico = res.data.desciv!==null?res.data.desciv.replace("''", "'"):"";
                this.import = res.data.import !== null?res.data.import:0;
                this.localitaDestinatario = res.data.desloc!==null?res.data.desloc.replace("''", "'"):"";
                this.provinciaDestinatario = res.data.desprv!==null?res.data.desprv.replace("''", "'"):"";
                this.capDestinatario = res.data.descap!==null?res.data.descap.replace("''", "'"):"";
                this.riferimentoDdt = res.data.numddt!=null?res.data.numddt.replace("''", "'"):"";
                this.preavvisare = res.data.srvpre ===1?true:false;
                this.telefonoPreavviso = res.data.pretel!==null?res.data.pretel.replace("''", "'"):"";
                this.emailMittenteTracking = res.data.mailme === 1?1:0;
                this.emailDestinatarioTracking = res.data.mailtu === 1?1:0;
                this.indirizzoMailDestinatario = res.data.maides!==null?res.data.maides.replace("''", "'"):"";
                this.numeroColli = res.data.numcol;
                this.peso = res.data.pesokg;
                this.volume = res.data.volmec;
                this.epalDaRendere = res.data.banren;
                this.epalARendere = res.data.banren != null && res.data.banren > 0?{value: 1}: {value:0};
                if(this.epalARendere.value === 1)
                  this.sceltaEpal = 1;
                //console.log("epal a rendere: " + this.epalARendere.value);
                this.lunghezza = res.data.lun200;
                this.misuraSelezionata = res.data.lun200mis!== null && res.data.lun200mis!== ""?{value: Number(res.data.lun200mis)}:{text: "NON IMPOSTATA", value: 0};
                this.misuraScelta =res.data.lun200mis!== null && res.data.lun200mis!== ""? Number(res.data.lun200mis):0;
                this.contrassegno = res.data.contra;
                this.valoreMerce = res.data.valore;
                // this.dispo1Selezionata = res.data.dispo1 !== null && res.data.dispo1 !== ""?{value: res.data.dispo1}:{value: this.disposizioni1[0].value};
                this.tipoIncasso = res.data.tipinc !== null && res.data.tipinc !== "" && res.data.tipinc !== " " && res.data.tipinc !== "0"?res.data.tipinc:" ";
                this.incassoSelezionato = {value: this.tipoIncasso};
                this.GetTipoIncasso(this.tipoIncasso);
                //console.log(this.tipoIncasso);
                //console.log(this.incassoSelezionato);
                this.dispo1Selezionata = res.data.dispo1 !== null && res.data.dispo1 != ""?{value: res.data.dispo1}:{value: " "};
                this.dispo1Scelta = res.data.dispo1 !== null && res.data.dispo1 != "" ?res.data.dispo1:" ";
                
                this.dispo2Selezionata = res.data.dispo2 !== null && res.data.dispo2 != "" && res.data.dispo2 !== "U"?{value: res.data.dispo2}:{value: " "};
                this.dispo2Scelta = res.data.dispo2 !== null && res.data.dispo2 != "" && res.data.dispo2 !== "U" ?res.data.dispo2:" ";
                this.servizioAggiuntivoSelezionato = res.data.seracc !== null && res.data.seracc !== ""?{value: res.data.seracc}:{value: " "};
                this.GetServizioAggiuntivo(res.data.seracc);
                this.centroStorico = res.data.censto === "1"?true:false;
                this.provaConsegna = res.data;
                this.pianoConsegna = res.data.piacon;
                this.concordataTassativa = res.data.tipcon == -1 || res.data.tipcon == null?false:true;
                if(this.tassativeAmmesse.includes(res.data.tipcon)){
                  this.tassativaSelezionata = {value: res.data.tipcon};
                }
                else{
                  this.tassativaSelezionata = {value: null};
                }
                if(res.data.datcon!=="1900-01-01T00:00:00" && res.data.datcon !== null && res.data.datcon!=="0001-01-01T00:00:00"){
                  this.data_partenza = res.data.datcon.substr(0,10);
                  if(res.data.tipcon == -1){
                    this.concordataTassativa = true;
                    this.tassativaSelezionata = {value: 0};
                  }
                }
                
                /////////////////////////////////////////////////////
                this.oreAMattino = res.data.orapma !== null?res.data.orapma.substr(0,2):"";
                this.minutiAMattino = res.data.orapma !== null?res.data.orapma.substr(2,2):"";
                this.oreCMattino = res.data.orchma !== null?res.data.orchma.substr(0,2):"";
                this.minutiCMattino = res.data.orchma !== null?res.data.orchma.substr(2,2):"";
                this.oraAPomeriggio = res.data.orappo !== null?res.data.orappo.substr(0,2):"";
                this.minutiAPomeriggio = res.data.orappo !== null?res.data.orappo.substr(2,2): "";
                this.oraCPomeriggio = res.data.orchpo !== null?res.data.orchpo.substr(0,2):"";
                this.minutiCPomeriggio = res.data.orchpo !== null?res.data.orchpo.substr(2,2):"";
                /////////////////////////////////////////////////////
                this.lunedi = res.data.giochi === null || res.data.giochi.substr(0,1) === " "?1:res.data.giochi.substr(0,1) === "M"?2:res.data.giochi.substr(0,1) === "P"?3:res.data.giochi.substr(0,1) === "T"?4:1;
                this.martedi = res.data.giochi === null || res.data.giochi.substr(1,1) === " "?1:res.data.giochi.substr(1,1) === "M"?2:res.data.giochi.substr(1,1) === "P"?3:res.data.giochi.substr(1,1) === "T"?4:1;
                this.mercoledi = res.data.giochi === null || res.data.giochi.substr(2,1) === " "?1:res.data.giochi.substr(2,1) === "M"?2:res.data.giochi.substr(2,1) === "P"?3:res.data.giochi.substr(2,1) === "T"?4:1;
                this.giovedi = res.data.giochi === null || res.data.giochi.substr(3,1) === " "?1:res.data.giochi.substr(3,1) === "M"?2:res.data.giochi.substr(3,1) === "P"?3:res.data.giochi.substr(3,1) === "T"?4:1;
                this.venerdi = res.data.giochi === null || res.data.giochi.substr(4,1) === " "?1:res.data.giochi.substr(4,1) === "M"?2:res.data.giochi.substr(4,1) === "P"?3:res.data.giochi.substr(4,1) === "T"?4:1;
                //leggo i valori di sola lettura della bolla
                this.notspe = res.data.notspe;
                this.fildes = res.data.fildes;
                this.gatdes = res.data.gatdes;
                this.instrada = res.data.instrada;
                this.datdis = res.data.datdis;
                this.segsta = res.data.segstra;
                this.insalt = res.data.insalt;
                this.mitrag = res.data.mitrag;
                this.mitind = res.data.mitind;
                this.mitloc = res.data.mitloc;
                this.mitcap = res.data.mitcap;
                this.mitprv = res.data.mitprv;
                this.palaper = res.data.palaper;
                //20202511
                this.ControllaUrgente();

                //recupero misure e adr
                this.JsonModifica["misure"] = [];
                this.JsonModifica["adr"] = [];
                axios.get(this.$store.state.servicePath + "/api/ArBolleDets/" + this.numeroSpedizione).
                then(res=> {
                  res.data.forEach(el =>{
                    var element = el;
                    element.mispes = Math.round(el.mispes * 10) /10;
                    this.JsonModifica["misure"].push(element);
                  })
                  //this.JsonModifica["misure"] = res.data;
                  if(this.JsonModifica["misure"].length > 0){
                    this.MisureBancali = this.JsonModifica["misure"];
                    this.dettaglioColli = true;
                  }
                axios.get(this.$store.state.servicePath + "/api/ArBolleAdrs/" + this.numeroSpedizione).
                then(res=> {
                  this.JsonModifica["adr"] = res.data;
                  if(this.JsonModifica["adr"].length > 0){
                    this.datiADR = this.JsonModifica["adr"];
                    this.mostraADR = true;

                  }
                
                }
                );
                }
                );
            }
            );
            this.overlay = false;
    },
    
    CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    },
    CheckResa(){
      
        axios
          .post(this.$store.state.servicePath + "/api/ArBolleSpes/tempiResa/" + this.numeroSpedizione, {
            numddt : this.riferimentoDdt.replace("'", "''"),
            desrag  : this.ragioneSocialeDestinatario.replace("'", "''"),
            desind : this.indirizzoDestinatario.replace("'", "''"),
            desloc : this.localitaDestinatario.replace("'", "''"),
            descap : this.capDestinatario.replace("'", "''"),
            desprv : this.provinciaDestinatario.replace("'", "''"),
            numcol : Number((this.numeroColli==null ? "0":this.numeroColli.toString().replace(",","."))),
            pesokg : Number((this.peso==null ? "0":this.peso.toString().replace(",","."))),
            volmec : Number((this.volume==null ? "0" : this.volume.toString().replace(",","."))),
            lun200 : Number((this.lunghezza==null ? "0":this.lunghezza.toString().replace(",","."))),
            lun200mis : this.misuraScelta,
            valore : Number((this.valoreMerce==null ? "0":this.valoreMerce.toString().replace(",", "."))),
            contra : Number((this.contrassegno==null ? "0":this.contrassegno.toString().replace(",","."))),
            tipinc : this.tipoIncasso,
            datCon : this.data_partenza,
            tipCon : this.tassativaSelezionata.value,
            dispo1 : this.dispo1Scelta,
            dispo2 : this.dispo2Scelta,
            pretel : this.telefonoPreavviso.replace("'", "''"),
            giochi : this.giorniChiusura,
            srvpre : this.preavvisare?1:0,
            notspe : this.notspe,
            stato : 1,
            fildes : this.fildes,
            gatdes : this.gatdes,
            instrada : this.instrada,
            datdis : this.datdis,
            banren : this.epalDaRendere,
            segsta : this.segsta,
            maides : this.indirizzoMailDestinatario.replace("'", "''"),
            mailme : this.emailMittenteTracking?1:0,
            mailtu : this.emailDestinatarioTracking?1:0,
            sentme : 0,
            senttu : 0,
            insalt : this.insalt,
            numcon : 0,
            piacon : this.pianoConsegna,
            mitrag : this.mitrag,
            mitind : this.mitind,
            mitloc : this.mitloc,
            mitcap : this.mitcap,
            mitprv : this.mitprv,
            prenota : 0,
            detcol : this.dettaglioColli?1:0,
            orapma : this.oreAMattino + this.minutiAMattino,
            orchma : this.oreCMattino + this.minutiCMattino,
            orappo : this.oraAPomeriggio + this.minutiAPomeriggio,
            orchpo : this.oraCPomeriggio + this.minutiCPomeriggio,
            segeffsta : 0,
            collante : this.collante,
            seracc : this.servizioScelto,
            censto : this.centroStorico?1:0,
            tipprov : 0,
            palaper : this.palaper,
            pdccom : this.scansioneLDV?1:0,
          })
          .then(res => {
              if(res.data != ""){
                if(res.data.includes("URGENTE") && this.tassativaSelezionata.value === 0){
                    this.overlay = false;
                    this.forzaUrgente = true;
                    this.disposizioni2.push({text: "URGENTE", value: "U"});
                    this.readonlyurgente = true;
                    this.dispo2Scelta = "U";
                    this.dispo2Selezionata = {text: "URGENTE", value: "U"};
                    this.DialogUrgente = true;
                    this.messageUrgente = "La data impostata ha richiesto l'impostazione automatica della disposizione URGENTE.";
                }
                else{
                  if(!res.data.includes("URGENTE")){
                    this.overlay = false;
                    this.erroreResa = true;
                    this.messageResa = res.data;
                  }
                  else{
                    this.Submit();
                  }
                }
              }
              else{
                this.Submit();
              }
            
          });
      
      
    },
    Indietro(){
      window.location.href ="/#/Bollettazione";
    },
    CambiaTassSelezionata(){
      //console.log(this.tassativaSelezionata.value);
      if(this.concordataTassativa)
        this.tassativaSelezionata = {value: 0};
      
      if(this.concordataTassativa === false){
        this.tassativaSelezionata = {value: -1};

      }
      this.data_partenza = "";
      this.ControllaUrgente();
    },
    StampaImmediataA4(){
      this.stampaImmediataA4 = 1;
      this.Validate();
    },
    StampaImmediata10(){
      this.stampaImmediata10 = 1;
      this.Validate();
    },
    StampaEtichette10(numsped){
      var sped = [];
      sped.push(numsped);
      
      axios.post(this.$store.state.servicePath + "/api/Print/Etichette", sped)
      .then(res=>{
        var pdf = res.data;
        //window.open("data:application/pdf;base64, " + res.data);
        var pdfWindow = window.open(pdf, '_blank');
        pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        this.AggiornaStato(sped);
        
      });
    },
    StampaEtichetteA4(numsped){
      var sped = [];
      sped.push(numsped);
      
      axios.post(this.$store.state.servicePath + "/api/Print/EtichetteA4", sped)
      .then(res=>{
        var pdf = res.data;
        //window.open("data:application/pdf;base64, " + res.data);
        var pdfWindow = window.open(pdf, '_blank');
        pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        this.AggiornaStato(sped);
      });
    },
    AggiornaStato(sped){      
      axios.put(this.$store.state.servicePath + "/api/ArBolleSpes/Aggiorna/2", sped)
      .then(res=>{
        var pdf = res.data;
        this.Cerca();
        window.location.href ="/#/Bollettazione";
      });
    },
    CheckContrassegno(valore) {
      if(valore === null || valore === undefined || valore === "") {
        valore = "0";
      }
      if(typeof valore == 'string')
        valore = valore.replace(",",".");
      var retVal = Number(valore)>0;
      return retVal;
    },
    CheckPunti(value){
      if(value === null || value === undefined)
        value = "0";
      if(typeof value == 'number')
        return true;
      var result = [];
      var regcheckDots = /[.]/g;
      result = value.match(regcheckDots);
      if(result != null)
        if(result.length > 1)
          return false;
        else
          return true;
      return true;
    },    
    GetBolleDestino(){
      this.autocomplete = [];
      axios.get(this.$store.state.servicePath + "/api/ArBolleSpes/GetDestinoBolle")
      .then(res =>{
        res.data.forEach(el=>{
          var element = {};
          element = el.desrag.replace("''", "'");
          this.autocompletamento[el.desrag.replace("''", "'")] = el;
          this.autocomplete.push(element);
        })
      })
    },
    ReplaceComma(val){
      this.val = val.replace(",", ".");
    },
    IndietroLista(){
      this.dialogNotSave = false;
      window.location.href ="/#/Bollettazione";
    },
    ControllaUrgente(){
      if(this.tassativaSelezionata.value !== 4){
        axios
          .post(this.$store.state.servicePath + "/api/ArBolleSpes/tempiResa/" + this.numeroSpedizione, {
            numddt : this.riferimentoDdt.replace("'", "''"),
            desrag  : this.ragioneSocialeDestinatario.replace("'", "''"),
            desind : this.indirizzoDestinatario.replace("'", "''"),
            desloc : this.localitaDestinatario.replace("'", "''"),
            descap : this.capDestinatario.replace("'", "''"),
            desprv : this.provinciaDestinatario.replace("'", "''"),
            numcol : Number((this.numeroColli==null ? "0":this.numeroColli.toString().replace(",","."))),
            pesokg : Number((this.peso==null ? "0":this.peso.toString().replace(",","."))),
            volmec : Number((this.volume==null ? "0" : this.volume.toString().replace(",","."))),
            lun200 : Number((this.lunghezza==null ? "0":this.lunghezza.toString().replace(",","."))),
            lun200mis : this.misuraScelta,
            valore : Number((this.valoreMerce==null ? "0":this.valoreMerce.toString().replace(",", "."))),
            contra : Number((this.contrassegno==null ? "0":this.contrassegno.toString().replace(",","."))),
            tipinc : this.tipoIncasso,
            datCon : this.data_partenza !== null && this.data_partenza !== ""? this.data_partenza : new Date(),
            tipCon : this.tassativaSelezionata.value,
            dispo1 : this.dispo1Scelta,
            dispo2 : " ",
            pretel : this.telefonoPreavviso.replace("'", "''"),
            giochi : this.giorniChiusura,
            srvpre : this.preavvisare?1:0,
            notspe : this.notspe,
            stato : 1,
            fildes : this.fildes,
            gatdes : this.gatdes,
            instrada : this.instrada,
            datdis : this.datdis,
            banren : this.epalDaRendere,
            segsta : this.segsta,
            maides : this.indirizzoMailDestinatario.replace("'", "''"),
            mailme : this.emailMittenteTracking?1:0,
            mailtu : this.emailDestinatarioTracking?1:0,
            sentme : 0,
            senttu : 0,
            insalt : this.insalt,
            numcon : 0,
            piacon : this.pianoConsegna,
            mitrag : this.mitrag,
            mitind : this.mitind,
            mitloc : this.mitloc,
            mitcap : this.mitcap,
            mitprv : this.mitprv,
            prenota : 0,
            detcol : this.dettaglioColli?1:0,
            orapma : this.oreAMattino + this.minutiAMattino,
            orchma : this.oreCMattino + this.minutiCMattino,
            orappo : this.oraAPomeriggio + this.minutiAPomeriggio,
            orchpo : this.oraCPomeriggio + this.minutiCPomeriggio,
            segeffsta : 0,
            collante : this.collante,
            seracc : this.servizioScelto,
            censto : this.centroStorico?1:0,
            tipprov : 0,
            palaper : this.palaper,
            pdccom : this.scansioneLDV?1:0,
          })
          .then(res => {
              if(res.data.includes("URGENTE") && this.tassativaSelezionata.value === 0){
                this.forzaUrgente = true;
                this.disposizioni2.push({text: "URGENTE", value: "U"});
                this.readonlyurgente = true;
                this.dispo2Scelta = "U";
                this.dispo2Selezionata = {text: "URGENTE", value: "U"};
                this.DialogUrgente = true;
                this.messageUrgente = "La data impostata ha richiesto l'impostazione automatica della disposizione URGENTE.";
              }
              else{
                var index = this.disposizioni2.findIndex(d => d.value === "U")
                this.disposizioni2.splice(index, 1)
                this.readonlyurgente = false;
                if(this.dispo2Scelta === "U"){
                  this.dispo2Scelta = " ";
                  this.dispo2Selezionata = {text: "NESSUNO", value: " "};
                }
              
              }
              
          });
      }
      else{
          var index = this.disposizioni2.findIndex(d => d.value === "U")
          this.disposizioni2.splice(index, 1)
          this.readonlyurgente = false;
          if(this.dispo2Scelta === "U"){
            this.dispo2Scelta = " ";
            this.dispo2Selezionata = {text: "NESSUNO", value: " "};
          }
        
        }
    }
    // customFilter(item, queryText, itemText){
      

    //   console.log(item.indexOf(queryText) > -1);
    // },
  
  },

  watch:{
    preavvisare: function(value){
      if(!value)
        this.telefonoPreavviso = "";
    //   if(value){
    //     if(this.dispo1Selezionata == "E")
    //       this.dispo1Selezionata = " ";
    //     if(this.dispo2Selezionata == "E")
    //       this.dispo2Selezionata = " ";
    //   }
    },
    // dispo2Selezionata: function(value){
    //   if(value == "E"){
    //     this.telefonoPreavviso = "";
    //     this.preavvisare = false;
    //   }

    // },
    // dispo1Selezionata: function(value){
    //   if(value == "E"){
    //     this.telefonoPreavviso = "";
    //     this.preavvisare = false;
    //   }
        
    // },
    kgADRInseriti: function(value){
      this.kgADRInseriti = value.replace(",", ".");
    },
    pesoInserito: function(value){
      this.pesoInserito = value.replace(",", ".");
    },
    peso: function(value){
        this.peso = value.replace(",", ".");
    },
    volume: function(value){
      this.volume = value.replace(",", ".");
    },
    contrassegno: function(value){
      this.contrassegno = value.replace(",", ".");
      if(value == null || value == undefined || value == "0"){
        this.tipoIncasso = " ";
        this.incassoSelezionato = {value: " "};
      }
    },
    valoreMerce: function(value){
      this.valoreMerce  = value.replace(",", ".");
    },
    selected(val){
      if(val === null)
        val = "";
      if(val in this.autocompletamento){
        this.ragioneSocialeDestinatario = this.autocompletamento[val].desrag.replace("''", "'");
        this.indirizzoDestinatario = this.autocompletamento[val].desind.replace("''", "'");
        this.civico = this.autocompletamento[val].desciv;
        this.localitaDestinatario = this.autocompletamento[val].desloc.replace("''", "'");
        this.provinciaDestinatario = this.autocompletamento[val].desprv.replace("''", "'");
        this.capDestinatario = this.autocompletamento[val].descap.replace("''", "'");
      }
      else{
        var index = this.autocomplete.indexOf(val.substring(0,val.length -1));
        // if(index !== null && index != undefined)
        //   this.autocomplete.splice(index, 1);
        this.autocomplete.push(val);
        this.autocompletamento[val] = {desrag: "", desind: "", desciv: "", desloc: "", desprv: "", descap: ""};
        this.ragioneSocialeDestinatario = this.autocompletamento[val].desrag.replace("''", "'");
        this.indirizzoDestinatario = this.autocompletamento[val].desind.replace("''", "'");
        this.civico = this.autocompletamento[val].desciv;
        this.localitaDestinatario = this.autocompletamento[val].desloc.replace("''", "'");
        this.provinciaDestinatario = this.autocompletamento[val].desprv.replace("''", "'");
        this.capDestinatario = this.autocompletamento[val].descap.replace("''", "'");
      }
    }
  }
};
</script>
